export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      agency: 'Agence',
      projects: 'Projets',
      missions: 'Missions',
      contact: 'Contacts',
      news: 'Actualités'
    },
    home: {
      title: 'Architecture méditerranéenne à Montpellier',
      subtitle: 'Créez des espaces qui vous inspirent',
      discover: 'Voir nos projets',
      startProject: 'Démarrer un projet',
      
      // Section Expertise/USP
      expertise: {
        title: 'Votre vision, notre expertise',
        intro: 'Cabinet d\'architecture basé à Montpellier, nous accompagnons projets publics et privés avec une approche sur-mesure alliant créativité, performance énergétique et respect de l\'environnement.',
        
        usp1: {
          title: '30+ ans d\'expérience',
          text: 'Expertise reconnue en conception résidentielle, individuelle, tertiaire et conception durable.'
        },
        usp2: {
          title: 'Approche sur-mesure',
          text: 'Chaque projet est unique adapté et pensé dans le respect de votre vision et de son environnement'
        },
        usp3: {
          title: 'Performance énergétique',
          text: 'Bâtiments RE2020, BBC, passifs : nous intégrons les dernières normes environnementales'
        },
        
        cta: 'En savoir plus sur l\'agence'
      },
      
      // Section Projets phares
      featured: {
        title: 'Projets réalisés',
        intro: 'Découvrez nos réalisations récentes en logement collectif, habitat individuel et aménagement urbain',
        viewProject: 'Voir le projet',
        cta: 'Voir tous les projets'
      },
      
      // Section Processus
      process: {
        title: 'Notre accompagnement',
        intro: 'Un processus clair et collaboratif du premier contact à la livraison',
        
        step1: {
          title: 'Écoute & Analyse',
          text: 'Nous étudions vos besoins, contraintes et aspirations pour définir ensemble le projet idéal'
        },
        step2: {
          title: 'Conception',
          text: 'Esquisse, AVP, PRO : nous créons un projet architectural qui répond à vos attentes et au site'
        },
        step3: {
          title: 'Suivi de chantier',
          text: 'Assistance technique et pilotage pour garantir la conformité et la qualité de réalisation'
        },
        step4: {
          title: 'Livraison',
          text: 'Réception des travaux et accompagnement pour une prise en main optimale de votre bâtiment'
        }
      },
      
      // Section Services
      services: {
        title: 'Nos domaines d\'intervention',
        
        collective: {
          title: 'Habitat collectif',
          text: 'Logements collectifs, intermédiaires et groupés',
          link: 'En savoir plus'
        },
        individual: {
          title: 'Habitat individuel',
          text: 'Villas sur-mesure, villas passives, extensions et rénovations',
          link: 'En savoir plus'
        },
        territory: {
          title: 'Tertiaire',
          text: 'Études urbaines, ZAC, équipements publics, requalification d\'espaces',
          link: 'En savoir plus'
        }
      },
      
      // CTA finale
      ctaFinal: {
        title: 'Prêt à donner vie à votre projet ?',
        text: 'Que vous soyez un particulier, un promoteur ou une collectivité, nous sommes à votre écoute pour transformer votre vision en réalité.',
        contact: 'Nous contacter',
        projects: 'Voir nos réalisations'
      }
    },
    agency: {
      title: 'Architecte à Montpellier',
      presentation: 'Présentation',
      society: 'La Société',
      philosophy: 'Notre Philosophie',
      team: 'L\'Équipe',
      partners: 'Les principaux intervenants',
      bet: 'Bureaux d\'Études Techniques (BET)',
      structure: 'Structure',
      fluides: 'Fluides',
      geometre: 'Géomètre',
      desamiantage: 'Désamiantage',

      logiciels: "Principaux logiciels utilisés",
      
      tagline: 'Architecture contemporaine, l\'agence vous apporte plus de 30 ans d\'expérience dans la conception architecturale et le management de projets complexes.',
      
      presentationText: 'Daniela Parito Architecture regroupe architectes et partenaires, avec comme principaux secteurs d\'activité l\'habitat collectif et individuel en neuf comme en réhabilitation, ainsi que les établissements recevant du public (ERP). L\'agence a remporté plusieurs concours publics et consultations promoteurs pour le compte de bailleurs sociaux, de promoteurs et de collectivités locales. Elle a traité en parallèle les études et la réalisation de projets de restructuration et de construction pour des particuliers.',
      
      philosophyText:  'Notre approche privilégie la qualité architecturale, le respect de l\'environnement et l\'innovation. Chaque projet est pensé comme une réponse unique à son contexte, ses contraintes et ses ambitions. L\'écoute et le dialogue en amont et pendant le projet, établie avec les maîtres d\'ouvrages et les partenaires techniques, est la base de notre démarche de qualité. Notre priorité : le confort des usagers tout en veillant à une parfaite intégration urbaine et au strict respect du budget.',
      philosophyText2: "Comprendre un projet pour trouver la solution parfaitement intégrée et adaptée, c’est aussi notre conception de l’architecture méditerranéenne.",
      
      societyText: 'Créé en octobre 2014 par sa gérante actuelle, Daniela PARITO, l\'agence s\'est concentrée dans un premier temps sur la réponse à des concours ouverts et a traité en parallèle les études et la réalisation de projets de restructuration et de construction pour des particuliers. L\'approche individualisée de l\'usage et de l\'esthétique, l\'écriture contemporaine de chaque projet, la prise en compte des contraintes environnementales et juridiques, le respect du budget sont des points forts majeurs de l\'agence et reconnus par ses clients.',
      
      collaborationIntro: {
        paragraph1: 'La réussite d\'un projet architectural nécessite une approche simple et directe à tous les niveaux. Dans ses relations avec les différents acteurs à l\'intérieur du groupement et avec le maître de l\'Ouvrage comme avec les acteurs institutionnels.',
        paragraph2: 'En fonction des spécificités de chaque projet et selon les phases d\'études, l\'agence fait appel à des intervenants extérieurs spécialisés, avec lesquels elle collabore sur ses projets. De telle manière, l\'agence s\'enrichit en permanence de pratiques et de réflexions croisées.',
        paragraph3: 'Ce fonctionnement souple et flexible, constitue une équipe dynamique et expérimentée qui nous permet de répondre à la demande du maître d\'ouvrage avec qualité, rigueur et dans le respect des délais.'
      },
      
      teamMembers: [
        {
          name: 'Daniela PARITO SORRENTI',
          role: 'Architecte & CEO',
          bio: 'Fondatrice de l\'agence, Daniela PARITO apporte plus de 30 ans d\'expérience dans la conception architecturale et le management de projets complexes.',
          summary: "Architecte diplômée de la Faculté d'Architecture et d'Urbanisme de Rome (Doctorat en 1990), Daniela PARITO fonde son agence à Montpellier en 2014, après 24 ans d'expérience dans des grandes agences parisiennes et régionales. Spécialisée dans l'habitat collectif et individuel ainsi que les équipements publics, elle conjugue expertise technique, sensibilité méditerranéenne et engagement pour une architecture durable et humaine."
        }
      ]
    },
    projects: {
      title: 'Nos réalisations dans l\'Hérault',
      all: 'Voir tous les projets',
      collective: 'Habitat Collectif',
      individual: 'Habitat Individuel',
      territory: 'Tertiaire',
      competitions: 'Concours',
      viewProject: 'Voir le projet'
    },
    missions: {
      title: 'Nos missions d\'architecte',
      subtitle: 'Profitez d\'une expertise et un accompagnement sur mesure grâce à nos 30 ans d\'expérience.',
      
      // Introduction
      intro: "Depuis plus de 30 ans, Daniela Parito Architecture accompagne ses clients dans la conception et la réalisation de projets architecturaux d'envergure. Notre expertise couvre l'ensemble du cycle de vie d'un projet, de l'esquisse initiale à la livraison finale, en passant par le suivi de chantier et la coordination des équipes.",
      
      // Types de missions
      types: [
        {
          title: 'Conception architecturale',
          description: 'De l\'esquisse à la réalisation, nous développons des projets sur mesure adaptés à vos besoins et contraintes.',
          highlights: [
            'Études de faisabilité et programmation',
            'Conception architecturale (AVP, PRO, DCE)',
            'Assistance aux marchés de travaux',
            'Suivi de chantier et OPC'
          ]
        },
        {
          title: 'Habitat collectif',
          description: 'Conception de résidences collectives alliant qualité de vie, performance énergétique et insertion urbaine.',
          highlights: [
            'Logements sociaux et aidés',
            'Résidences en accession libre',
            'Performance énergétique (RE2020, BBC)',
            'Insertion urbaine et paysagère'
          ]
        },
        {
          title: 'Habitat individuel',
          description: 'Maisons contemporaines pensées pour votre mode de vie, en harmonie avec leur environnement.',
          highlights: [
            'Maisons contemporaines sur mesure',
            'Villas passives et BBC',
            'Extensions et rénovations',
            'Architecture méditerranéenne'
          ]
        },
        {
          title: 'Tertiaire',
          description: 'Conception et réalisation d\'équipements publics. Fonctionnalité et esthétique au service des futurs utilisateurs.',
          highlights: [
            'Équipements publics (ERP)',
            'Bâtiments administratifs',
            'Réhabilitations et mises en conformité',
            'Équipements sportifs et culturels'
          ]
        }
      ],
      
      // Phases du projet
      phases: {
        studies: {
          title: 'Phase études',
          content: [
            'Les études prendront en compte la spécificité de l\'opération et notamment sa localisation urbaine et dans le paysage, l\'analyse de la réglementation applicable à la zone, les attentes en matière d\'économie d\'énergie liées à la certification RE2020 ainsi que les objectifs attendus par le Maître d\'Ouvrage.',
            'Nous travaillerons sur la performance énergétique, la qualité d\'usage des espaces, la qualité de l\'air et le confort acoustique et proposerons la solution technique et environnementale optimale, dans le respect du coût d\'objectif de l\'opération.'
          ]
        },
        works: {
          title: 'Phase travaux',
          subsections: [
            {
              title: 'Préparation du chantier',
              content: [
                'En phase préparatoire, les principales missions de l\'équipe de maîtrise d\'œuvre seront la mise au point de toutes les interventions objet du marché des entreprises, la gestion des délais, la planification des travaux et la diffusion au Maître d\'Ouvrage d\'une information régulière sur l\'évolution du projet.'
              ]
            },
            {
              title: 'Phase de réalisation des travaux',
              content: [
                'En phase chantier, les points essentiels pour l\'équipe de maîtrise d\'œuvre seront la maîtrise des délais et des nuisances, le respect des réglementations techniques, la maîtrise des coûts.',
                'Pendant l\'exécution des travaux, notre équipe contrôlera régulièrement la qualité et la conformité des ouvrages et en tiendra informé le Maître d\'Ouvrage.'
              ]
            },
            {
              title: 'Phase de réception des travaux',
              content: [
                'Dans le cadre des opérations préalables à la réception du bâtiment, chaque intervenant de l\'équipe de maîtrise d\'œuvre, dans son domaine de compétences et en constante concertation, se chargera de vérifier et d\'analyser la conformité des ouvrages réalisés et/ou à parfaire.',
                'Préalablement à la mise en service, une réunion à destination des utilisateurs et des usagers sera organisée avec la maîtrise d\'œuvre, pour les informer des spécificités des équipements et veiller à ce que leur exploitation pérennise la qualité et le bon fonctionnement des ouvrages.'
              ]
            }
          ]
        },
        greenSite: {
          title: 'Chantier vert',
          content: [
            'La Gestion Environnementale du Chantier est un élément majeur pour la qualité de la réalisation des travaux.',
            'Nous veillerons à minimiser les répercussions des nuisances sur la vie de chantier en matière de sécurité, de propreté et de maintien du niveau d\'excellence des travaux effectués par chaque entreprise.'
          ]
        },
        landscape: {
          title: 'Intégration paysagère',
          content: [
            'Le traitement des espaces extérieurs est également au cœur de notre démarche.',
            'Nous travaillerons sur l\'optimisation des voies de desserte, la création de voies douces, la végétalisation des espaces, la préservation et le développement d\'un milieu faune et flore afin de proposer « une architecture respectueuse de son environnement ».'
          ]
        }
      },
      
      // Section "Notre approche"
      approach: {
        title: 'Nos engagements',
        details: [
          {
            title: 'Exprimer une intention architecturale forte, volontaire et sensible, mais sans démesure',
            description: 'La qualité d\'écoute et de dialogue en amont et pendant le projet, établie avec les maîtres d\'ouvrages et les partenaires techniques, est la base de notre démarche de qualité.'
          },
          {
            title: 'Imaginer un cadre et des espaces de vie qualitatifs caractérisés avant tout par l\'usager',
            description: 'Toute proposition est au service d\'une qualité et d\'un confort des usagers tout en veillant à une parfaite intégration urbaine et au strict respect du budget.'
          },
          {
            title: 'Révéler un concept avec une approche soucieuse du contexte, de l\'environnement bâti et du paysage',
            description: 'L\'agence base sa réflexion sur une cohérence architecturale spécifique à chaque projet : de l\'intervention ponctuelle aux grands projets urbains.'
          },
          {
            title: 'Concevoir un projet en adéquation avec son milieu et pertinent en termes de Haute Qualité Environnementale',
            description: 'L\'engagement environnemental de l\'agence se traduit par une valorisation des filières courtes pour les matériaux de construction, une recherche globale d\'économie d\'énergie à l\'utilisation et une optimisation des moyens à la construction des bâtiments.'
          }
        ],
        items: [
          {
            title: 'Compromis technico-environnementaux',
            description: 'Rechercher les meilleurs compromis technico-environnementaux dans un souci du respect du coût d\'objectif de l\'opération.'
          },
          {
            title: 'Optimisation par la simulation',
            description: 'Optimiser les solutions proposées en ayant recours à des outils de simulations spécialisés pour garantir la performance et la faisabilité de chaque projet.'
          },
          {
            title: 'Management de projet',
            description: 'Garantir le suivi de la qualité du projet par l\'utilisation d\'un système de management de projet durant tout le déroulement de l\'opération.'
          },
          {
            title: 'Démarche collaborative',
            description: 'Une écoute attentive et un dialogue constant avec les maîtres d\'ouvrages et les partenaires techniques, de la conception à la livraison.'
          }
        ]
      }
    },
    contact: {
      title: 'Contact',
      name: 'Nom',
      email: 'Email',
      message: 'Message',
      send: 'Envoyer',
      sending: 'Envoi en cours...',
      success: 'Votre message a été envoyé avec succès !',
      error: 'Une erreur est survenue. Veuillez réessayer.',
      info: 'Informations de contact',
      address: '663 Rue du pré aux clercs',
      city: '34000 Montpellier, France',
      consentText: "J'accepte que mes données soient utilisées pour traiter ma demande, conformément à la",
      consentLink: 'politique de confidentialité'
    },
    news: {
      title: 'Nos actualités',
      subtitle: 'Suivez nos derniers projets et réalisations via notre actualité',
      readArticle: 'Lire l\'article',
      viewPdf: 'Voir le PDF'
    },
    bio: {
      formations: {
        title: "Formations",
        list: [
          "Doctorat en architecture D.F.A.U.R. (Faculté d'Architecture et d'Urbanisme de Rome – 1990)",
          "Habilitation d'État à la profession d'Architecte (Rome – 1996)",
          "DU Direction de Travaux Bâtiment (Montpellier – 2001)",
          "CSPS - Niveau 1 (Montpellier – 2001)",
          "Rénovation énergétique des maisons individuelles (Montpellier – 2020)",
          "Inscrite au Tableau de l'Ordre des Architectes – Région Occitanie sous le n° d'Ordre 046166",
          "Inscrite au Tableau de l'Ordre des Architectes – Région Occitanie sous le n° d'Ordre S16988"
        ]
      },
      
      logementsNeufs: {
        title: "Logements Neufs",
        concoursTitle: "Concours lauréats",
        projetsTitle: "Projets",
        
        concours: [
          {
            title: "Démolition de 49 et construction de 50 logements collectifs sociaux – Florensac (34510)",
            subtitle: "Cité Marcadal – Avenue de la Gardie",
            details: [
              "Architecte mandataire : Daniela PARITO Architecture",
              "Architecte associé : ARCHIZ",
              "SDP : 3643 m² // Montant prévisionnel : 5 807 700 €HT",
              "MO : HÉRAULT–LOGEMENT",
              "Mission complète (Tranche 3 – chantier en cours)"
            ]
          },
          {
            title: "Conception – Réalisation de 48 logements collectifs sociaux – ZAC PIERRES VIVES - Montpellier (34000)",
            subtitle: "Résidence Alfred Screve – Rue Marius Petipa",
            details: [
              "Mandataire du groupement : GIRAUD MIDI-PYRÉNÉES",
              "Architecte mandataire : Daniela PARITO Architecture",
              "Architecte associé : R+C2",
              "SDP : 3391 m² // Montant : 4 344 000 €HT",
              "MO : HÉRAULT–HABITAT",
              "Mission complète (Opération livrée – 2020)"
            ]
          },
          {
            title: "Construction de 20 logements collectifs sociaux – Maraussan (34370)",
            subtitle: "Résidence Les Semailles",
            details: [
              "SDP : 1288 m² // Montant : 1 900 000 €HT",
              "MO : HÉRAULT–HABITAT",
              "Mission complète (Opération livrée – Septembre 2018)"
            ]
          }
        ],
        
        projets: [
          {
            title: "Construction d'une résidence de 36 logements et un logement destiné à la colocation de 6 personnes handicapées – Beaucaire (30300)",
            details: [
              "SDP : 2669 m² // Montant : 4 200 000 €HT",
              "MO : EDOUARD DENIS",
              "Maîtrise d'œuvre de conception et suivi architectural (Études en cours)"
            ]
          },
          {
            title: "Construction de 69 logements – Lotissement « Le chemin des Vignes » - Port la Nouvelle (11210)",
            subtitle: "Résidence Le Corail",
            details: [
              "SDP : 4303 m² // Montant : 7 000 000 €HT",
              "MO : HABITAT AUDOIS",
              "Maîtrise d'œuvre de conception et suivi architectural (DCE en cours)"
            ]
          },
          {
            title: "Construction de 30 logements – Narbonne (11100)",
            details: [
              "SDP : 2158 m²",
              "MO : ENVOL",
              "Maîtrise d'œuvre de conception et suivi architectural (Études en cours)"
            ]
          },
          {
            title: "Construction de 24 logements – Frontignan (34110)",
            details: [
              "SDP : 1621 m² // Montant : 2 000 000 €HT",
              "MO : IDEOM",
              "Maîtrise d'œuvre de conception et suivi architectural (Projet abandonné)"
            ]
          },
          {
            title: "Construction de 34 logements dont 11 aidés – Résidence Patio Clément - Mauguio (34130)",
            details: [
              "SDP : 2139 m² // Montant : 2 600 000 €HT",
              "MO : ANGELOTTI PROMOTION",
              "Maîtrise d'œuvre de conception et suivi architectural (Opération livrée – Mars 2023)"
            ]
          },
          {
            title: "Démolition de l'ancienne cave coopérative et construction de 26 logements collectifs sociaux – Maureilhan (34370)",
            subtitle: "Résidence La Vigneronne",
            details: [
              "SDP : 1666 m² // Montant : 2 128 182 €HT",
              "MO : FDI HABITAT",
              "Mission complète (Opération livrée – Juillet 2022)"
            ]
          },
          {
            title: "Construction de 20 logements collectifs aidés - Résidence Pélissier - Mauguio (34130)",
            details: [
              "SDP : 1460 m² // Montant : 1 400 000 €HT",
              "MO : AMETIS",
              "Maîtrise d'œuvre de conception et suivi architectural (Opération livrée – Août 2022)"
            ]
          },
          {
            title: "Construction de 32 logements en accession libre – Résidence Park View - ZAC OVALIE Lot 23 C2 Montpellier",
            details: [
              "SDP : 1809 m² // Montant : 2 450 000 €HT",
              "MO : COGIM / LES VILLÉGIALES",
              "Maîtrise d'œuvre de conception et suivi architectural (Opération livrée – Septembre 2019)"
            ]
          }
        ]
      },
      
      tertiaire: {
        title: "Tertiaire",
        projets: [
          {
            title: "Réhabilitation de la Maison GALIBERT en Poste de Police Municipale - Baillargues (34670)",
            details: [
              "SU : 63 m² // Montant : 160 500 €HT",
              "MO : VILLE DE BAILLARGUES",
              "Mission complète (Opération livrée – Juin 2021)"
            ]
          },
          {
            title: "Réfection du Stade René Franques – Maîtrise d'œuvre des installations sportives - Florensac (34510)",
            details: [
              "SU : 445 m² + 164 m² (tribunes) // Montant : 816 000 €HT",
              "MO : VILLE DE FLORENSAC",
              "Mission complète (Opération livrée – Décembre 2022)"
            ]
          },
          {
            title: "Extension du local associatif (Club House) et réfection des vestiaires du Stade - Baillargues (34670)",
            details: [
              "SU : 213 m² dont 30 m² d'extension // Montant : 148 202 €HT",
              "MO : VILLE DE BAILLARGUES",
              "Mission complète (Opération livrée – mai 2018)"
            ]
          },
          {
            title: "Concept : microstation dédiée (GAZ GNV)",
            details: [
              "MO : SEVEN OCCITANIE",
              "Étude prototype (Juin 2018)"
            ]
          }
        ]
      },
      
      logementsIndividuels: {
        title: "Logements Individuels",
        projets: [
          {
            title: "Agrandissement d'une maison individuelle - Chameyrat (19330)",
            details: "SDP créée : 60 m² // Montant : 80 000 €HT // Maîtrise d'œuvre de conception (Mission terminée)"
          },
          {
            title: "Maison individuelle - Argelliers (34380)",
            details: "SDP : 222 m² // Montant : 500 000 €HT // Maîtrise d'œuvre de conception (Mission terminée)"
          },
          {
            title: "Maison individuelle – Quartier « Georges Bizet » - Baillargues (34670)",
            details: "SDP : 130 m² // Montant : 160 000 €HT // Maîtrise d'œuvre de conception (Mission terminée)"
          },
          {
            title: "Restructuration d'une villa – Saint-Aunés (34130)",
            details: "Montant : 140 000 €HT // Mission complète (Opération livrée)"
          },
          {
            title: "Extension d'un appartement – Le Crès (34920)",
            details: "SDP : 50 m² // Montant : 100 000 €HT // Maîtrise d'œuvre de conception (Mission terminée)"
          },
          {
            title: "Maison individuelle passive en ossature bois - Mondonville (31700)",
            details: "SDP : 130 m² // Montant : 300 000 €HT // Maîtrise d'œuvre de conception (Mission terminée)"
          },
          {
            title: "Extension d'une maison – Salina (Italie)",
            details: "SDP : 60 m² // Montant : 100 000 €HT // Maîtrise d'œuvre de conception (Mission terminée)"
          },
          {
            title: "Restructuration d'une maison de ville – Montpellier",
            details: "SDP : 108 m² // Montant : 200 000 €HT // Mission complète (Opération livrée)"
          }
        ]
      },
      
      concours: {
        title: "Concours & Consultations Promoteur",
        projets: [
          {
            title: "Réalisation d'un programme immobilier de 50 logements – Cité des Peupliers - Narbonne (11100)",
            details: "SDP : 3481 m² // Montant prévisionnel : 5 500 000 €HT // MO : Ville de Narbonne // Promoteur : ENVOL"
          },
          {
            title: "ZAC « PUITS DE ROULLE » - LOT 7 - Construction de 34 logements – Nîmes (30900)",
            details: "SDP : 2208 m² // MO : Ville de Nîmes // Promoteur : ENVOL"
          },
          {
            title: "Démolition et Construction de 27 logements locatifs sociaux - Florensac (34510)",
            details: "SDP : 1910 m² // Montant prévisionnel : 2 292 000 €HT // MO : HÉRAULT-LOGEMENT"
          },
          {
            title: "Construction de 45 logements – Secteur MARTINET « Cœur de Village » - Langlade (30980)",
            details: "SDP : 3110 m² // MO : SPL AGATE // Promoteur : ANGELOTTI PROMOTION"
          },
          {
            title: "Construction de 6 logements + commerces à RDC – Béziers (34500)",
            details: "SHAB : 268 m² - SU : 75 m² // MO : Ville de Béziers // Promoteur : ANGELOTTI PROMOTION – PROMO G"
          },
          {
            title: "Construction de 39 logements collectifs – ZAC CAMBACERES – Lot. B 1.1 – Montpellier",
            details: "SDP : 2756 m² // Montant prévisionnel : 3 M €HT + 0,8 M €HT (VRD) // MO : ACM"
          },
          {
            title: "Construction de 52 logements – ZAC CARRIERE DES AMOUREUX – Macrolot A – Garons",
            details: "SDP : 2800 m² // MO : SPL AGATE // Promoteur : ANGELOTTI PROMOTION // Bailleur social : UN TOIT POUR TOUS"
          },
          {
            title: "Construction de 60 logements – ZAC CARRIERE DES AMOUREUX – Macrolot C – Garons",
            details: "SDP : 3991 m² // MO : SPL AGATE // Promoteur : ANGELOTTI PROMOTION // Bailleur social : UN TOIT POUR TOUS"
          }
        ]
      },
      
      experiencePro: {
        title: "Expérience professionnelle",
        periods: [
          {
            years: "Octobre 2014",
            description: "Création de la SARL Daniela PARITO Architecture"
          },
          {
            years: "1998 à 2014 – Arles - Montpellier",
            description: "Expérience professionnelle en agence :",
            agencies: "BOYER-PERCHERON-ASSUS // Antoine GARCIA-DIAZ // François FONTES // François SEIGNEUR"
          },
          {
            years: "1990 à 1998 - Paris",
            description: "Expérience professionnelle en agence :",
            agencies: "VALODE & PISTRE // SCENOGRAPHIE // Scène // Antoine STINCO // Bernard KHON // Pierre EIDEKINS // DONATI-DUBORG // Élisabeth DOUSSET // GUFROY-HESTERS-LEFEBVRE"
          }
        ]
      }
    },
    projectDetails: {
      1: { // Zac PIERRES VIVES
        subtitle: "Résidence « Alfred Screve » - 48 logements collectifs sociaux à Montpellier, Lot 5 \nZAC Pierres Vives, rue Marius Petipa à Montpellier (34000)",
        shortDescription: "Résidence moderne de 48 logements collectifs intégrant des espaces verts et des équipements partagés.",
        fullDescription: "Cette résidence est située au cœur de la ZAC Pierres Vives, écoquartier de 10 hectares à la jonction de plusieurs quartiers de Montpellier. Pierres Vives est à la fois résidentiel et culturel et s’articule autour des archives départementales, bâtiment emblématique de Zaha Hadid. \nLe bâtiment, implanté en limite Sud du Parc boisé classé, offre à la fois une façade urbaine au Sud et une façade paysagée au Nord. Il est composé de 48 logements tous traversants et distribués par coursives ouvertes sur l’espace boisé classé.  \nIl s’agit d’un bâtiment tout en béton, marqué par l’horizontalité de ses bandeaux et de ses terrasses brisées. Tel un tressage, les bandeaux blancs ondulent, habillent et enveloppent tout en douceur la totalité des volumes. \nCette architecture aux formes organiques et naturelles offre un traitement homogène et cohérent.  \nAu Sud elle s’affirme comme un écran protecteur face aux nuisances « urbaines » : les bandeaux, ont le rôle alternativement, de garde-corps des terrasses et d’ombrières. Ils mettent en retrait le bâti et favorisent l’intimité́ des espaces privatifs extérieurs. Au Nord, elle s’ouvre et se fond dans le paysage naturel : les bandeaux se transforment en garde-corps des coursives et offrent une vue dégagée sur le Parc boisé classé. A l’angle Sud-Ouest, les bandeaux sortent en porte à faux de la façade et accompagnent l’angle urbain.",
        details: {
          mission: "Concours Lauréat - Conception-Réalisation",
          surface: "3391 m²",
          cost: "4.4 M€ HT",
          architecteAssocie: "R+C2",
          performance: "RT 2012",
          duration: "16 mois",
          client: "Hérault Habitat",
          year: "2019",
          team: [
            "BET Structure : PER INGENIERIE",
            "BET Fluides : Cabinet DURAND",
            "Coordonnateur SPS : ELYFEC",
            "Géomètre : GEO MECA",
            "Bureau de contrôle : DEKRA",
          ]
        }
      },
      2: { // RESIDENCE PARK VIEW
        subtitle: "Résidence « Park View » - 32 logements en accession libre - Lot 23C2 \nQuartier « Ovalie » à Montpellier (34000)",
        shortDescription: "Programme immobilier innovant au cœur du quartier Ovalie, privilégiant la qualité de vie et l'efficacité énergétique.",
        fullDescription: "La situation exceptionnelle de ces logements, en recul des grandes axes urbains, face au parc du Rieucoulon a naturellement conduit l’architecte à adopter un épannelage en cascade, favorisant une exposition et une vue privilégiée pour chaque logement. \nPour la grande majorité des 32 logements traversants, l’orientation des pièces de vie, des terrasses et des loggias, a été pensée en fonction du paysage environnant.  \nLes habitants ont tous accès au jardin calme et serein de la résidence et, plus loin, à celui du Parc. \nLa transition entre les espaces privatifs et l’extérieur a été gérée par un dispositif de brise-soleil en béton, à la forme d’un portique, localisé en avant plan des façades. Ce dispositif apporte ombre et fraicheur aux logements et cadre les vues, comme une « fenêtre s’ouvrant sur le Parc » … à travers laquelle l’on peut observer le paysage naturel tout en préservant l’intimité des terrasses privatives.",
        details: {
          mission: "Maîtrise d'œuvre de conception et Suivi Architectural (Opération livrée – Octobre 2019)",
          surface: "1809 m²",
          cost: "2.5 M€ HT",
          client: "Les Villégiales - Cogim",
          year: "2019",
          performance: "RT 2012",
          duration: "20 mois",
          team: [
            "BET Structure : Structure 2000",
            "BET Fluides : Cabinet DURAND",
            "Économiste + OPC : K2C BET",
            "Géomètre : EGSA",
            "Bureau de contrôle : SOCOTEC",
          ]
        }
      },
      3: { // RESIDENCE PELLISSIER
        subtitle: "Résidence « Maison Pelissier » - 20 logements collectifs aidés à Mauguio (34130)",
        shortDescription: "Ensemble résidentiel contemporain alliant architecture épurée et confort de vie en centre-ville.",
        fullDescription: "Intégrer une résidence en R+2 dans un quartier essentiellement composé de villas a guidé la réflexion de l’architecte. Elle a ainsi préservé l’équilibre du quartier en insérant le bâtiment dans son environnement architectural et culturel.  \nLes logements sont bien exposés, lumineux et tous traversants, entourant un cœur d’îlot paysagé et arboré qui distribue l’ensemble des appartements, tous ouverts sur cet espace de partage convivial et harmonieux. L’utilisation de la pierre à RDC et sur une partie des façades est un rappel à l’identité du cœur de Ville. \nCe projet, soutenu par la Mairie, respecte le caractère de la Ville de Mauguio : commune empreinte de traditions mêlées à la modernité. \nDans ce but, un soin tout particulier a été apporté à l’angle du bâtiment au croisement des deux rues. Il a ainsi été creusé pour abriter « les amateurs de tauromachie » à l’occasion des fêtes locales, lors du passage des taureaux qui, à cet endroit, se dirigent vers l’ancienne route des cabanes. \nLa forme arrondie du pignon sur rue est d’ailleurs un clin d’œil à la traditionnelle cabane du gardien.",
        details: {
          mission: "Maîtrise d'œuvre de conception et Suivi Architectural (Opération livrée – Août 2022)",
          surface: "1460 m²",
          cost: "1.4 M€ HT",
          client: "Ametis",
          year: "2022",
          performance: "RT 2012",
          team: [
            "BET Structure : RELIEF GE, BRINAS",
            "BET Fluides : ABM Énergie Conseil",
            "Économiste + OPC : K2C BET",
            "3D Manager",
            "Géomètre : EGSA",
            "Bureau de contrôle : QUALICONSULT",
          ]
        }
      },
      4: { // CITE MARCADAL
        subtitle: "Démolition de 49 logements & Construction de 50 logements collectifs sociaux à Florensac (34510)",
        shortDescription: "Réhabilitation urbaine respectueuse du patrimoine local, créant un dialogue entre tradition et modernité.",
        fullDescription: "Le fil directeur de ce projet a été la nécessité de redonner un nouvel élan de convivialité à un quartier vieillissant. De nouveaux lieux ont été créés, qui mêlent à la fois habitations accueillantes et fonctionnelles avec une qualité de vie liée à l’organisation et au traitement des espaces publics afin d’en faire des espaces facilitateurs du bien vivre ensemble.  \nLa conception des logements, tous traversants et aux pièces de vies toutes orientées, sud répond aux exigences d’économie d’énergie. \nL’opération est réalisée en trois phases : 49 logements sont progressivement démolis et 50 construits, sous forme de villas accolées ou en bande, à R+1, disposés par petits îlots et formant 4 ensembles réunis dans 1 seul quartier. \nL’humain a repris une place prépondérante au travers du traitement de points essentiels : un maillage piéton et cyclable organisé, une desserte aisée des groupes de maisons, l’accès facilité aux voitures garées en dehors des zones d’habitations collectives… \nLa disposition retenue offre une aération du bâti et permet des ouvertures latérales aux logements. \nLe projet est conçu avec un nombre restreint de typologies de logements (7 modules sur 50 logements), ce qui permet d’imbriquer « librement » chaque module à partir d’un noyau central composé, à la fois par les chambres ou par les séjours / garages. Il favorise la compacité du bâti, et libère de l’espace pour les jardins privatifs.",
        details: {
          mission: "Concours lauréat - Mission Complète (Chantier en cours)",
          surface: "3643 m²",
          cost: "5.9 M€ HT",
          client: "Hérault-Logement",
          year: "En cours",
          architecteAssocie: "ARCHIZ",
          performance: "RT 2012",
          duration: "36mois (en cours)",
          team: [
            "BET Pluridisciplinaire : BETEM",
            "BET Désamiantage et Démolition : ANTEA",
            "BET VRD : Cabinet SEIRI",
            "Économiste + OPC : BPTEC",
            "Bureau de contrôle : DEKRA",
            "Géomètre : SIRAGUSA"
          ]
        }
      },
      5: { // RESIDENCE LES SEMAILLES
        subtitle: "Résidence « Les Semailles » - Construction de 20 logements collectifs sociaux à Maraussan (34370)",
        shortDescription: "Projet de logements collectifs éco-responsables avec jardins partagés et espaces communs végétalisés.",
        fullDescription: "L’objectif de l’architecte a été de créer une continuité, un nouvel axe de promenade aménagé et paysagé, entre la ville basse et l’ancienne Cave Coopérative, symbole historique de la ville et de sa tradition agricole. Cela s’est traduit par la construction d’espaces méditerranéens ouverts et conviviaux dans lesquels s’intègrent harmonieusement les nouveaux logements, tous traversants et parfaitement fonctionnels. \nLes deux bandes d’habitations, travaillées en corps de bâti distincts se distribuent de part et d’autre de ce mail en suivant la déclivité naturelle du terrain.  \nLes cages d’escalier à l’air libre s’interposent entre les plots. Elles sont traitées comme des failles à ciel ouvert qui séquencent les volumes et permettent une mise à l’échelle à l’image des bâtiments avoisinants. \nCette disposition, qui constitue une perspective ouverte vers le haut du terrain et au-delà, permet une distribution proche et intuitive des logements, ce qui facilite la rencontre et le partage entre voisins.",
        details: {
          mission: "Concours lauréat - Mission Complète (Opération livrée - 2018)",
          surface: "1288 m²",
          cost: "1.9 M€ HT",
          client: "Hérault-Habitat",
          year: "2018",
          duration: "14 mois",
          performance: "RT 2012",
          team: [
            "BET Structure : ITS",
            "BET Fluides : Cabinet DURAND",
            "BET VRD : Cabinet SEIRI",
            "Économiste + OPC : BPTEC",
            "Bureau de contrôle : DEKRA",
            "Géomètre : Guillaume GASQUEZ"
          ]
        }
      },
      6: { // RESIDENCE LA VIGNERONNE
        subtitle: "Résidence « La Vigneronne » - Démolition de l’ancienne cave coopérative et construction de 26 logements collectifs sociaux à Maureilhan (34370)",
        shortDescription: "Architecture méditerranéenne contemporaine s'inspirant du terroir viticole local.",
        fullDescription: "Concilier tradition, esthétique, efficacité et sobriété a guidé la conception de ces logements dans une commune à forte tradition viticole. À l’emplacement de l’ancienne cave coopérative, la perspective dégagée a été accentuée pour mettre en valeur le site. Les toitures sont alternativement plates ou en tuile, avec une disposition en forme de rappel des formes et des couleurs de l’ancien bâtiment viticole. Afin de respecter notre objectif d’éco-conception, ce projet s’est basé sur des principes simples, efficaces et pragmatiques : \n- Conserver des volumes denses et compacts, avec peu de décrochés de façades, afin de minimiser les surfaces déperditives et favoriser l’objectif basse consommation. \n- Superposer les volumes et utiliser des procédés constructifs simples pour gagner en économie du projet. \n- Proposer des logements tous traversants permettant d’assurer une sur-ventilation estivale et de « décharger » les bâtiments de leur chaleur.",
        details: {
          mission: "Concours lauréat - Mission Complète (Opération livrée – Juillet 2021)",
          surface: "1666 m²",
          cost: "2.2 M€ HT",
          client: "FDI Habitat",
          year: "2021",
          performance: "RT 2012",
          duration: "16 mois",
          team: [
            "BET Structure : André VERDIER",
            "BET Fluides : Cabinet DURAND",
            "BET VRD : Cabinet SEIRI",
            "Économiste + OPC : BPTEC",
            "Géomètre  : E.G.S.A BTP",
            "Bureau de contrôle : DEKRA"
          ]
        }
      },
      7: { // Logements collectifs Frontignan
        subtitle: "Construction de 24 logements collectifs à Frontignan (34110)",
        shortDescription: "Ensemble de logements collectifs s'intégrant harmonieusement dans le tissu urbain existant.",
        fullDescription: "Le projet comporte 24 logements pour la plupart traversants. \nLa volumétrie épouse la morphologie du terrain. Dans cette configuration, le corps de bâtiment se trouve fractionné, créant un jeu de décalage des volumes et un jeu d’ombres qui viennent animer les façades. \nLes toitures en tuiles, font écho au tissu urbain environnant. \nLa perspective dégagée qui actuellement met en valeur la vigne depuis la rue de Belgique est conservée.  \nLa composition générale du projet privilégie l’expression traditionnelle. La colorimétrie choisie est douce, l’architecture étant essentiellement composée par ses volumes et ses rythmes de percements. \nLe cheminement de desserte des piétons, longe le bâtiment et distribue chaque hall d’entrée ainsi que son local vélo dédié. Au droit des halls d’entrée, l’élargissement ponctuel du cheminement permet de fluidifier la circulation des piétons et des vélos et favorise les échanges et le lien social entre les habitants de la résidence.",
        details: {
          mission: "Maîtrise d'œuvre de conception et suivi architectural (Projet abandonné)",
          surface: "1621 m²",
          cost: "2 M€ HT",
          client: "Ideom",
          performance: "RT 2012",
          duration: "12 mois",
          team: [
            "BET Structure : Setting",
            "BET Fluides : DEXO",
            "Géomètre  : GEOM 7",
            "Bureau de contrôle : SOCOTEC"
          ]
        }
      },
      8: { // Résidence Patio Clémént
        subtitle: "Résidence Patio Clémént - 34 logements collectifs dont 11 aidés à Mauguio (34130)",
        shortDescription: "Programme de logements au centre-ville alliant tradition et modernité architecturale.",
        fullDescription: "Le projet, se situe au centre de la Commune de Mauguio et prévoit la construction de 34 logements dont 11 logements aidés destinés à la location. \nIl se compose de deux corps de bâtiment en alignement avec l’avenue Jean-Baptiste Clément, chacun répondant à une règlementation spécifique du PLU. \nLe premier, sur 2 niveaux, est traité avec une toiture en tuiles canal à deux pentes. Il assure la continuité du front urbain avec le bâtiment voisin. \nLe deuxième, sur 3 niveaux au-dessus du parc de stationnement ouvert, se retourne à une distance règlementaire le long de la limite nord-ouest. Au R+3, les façades sont vêtues d’un bardage en zinc nervuré afin de recouvrir les parties de mur qui suivent la pente donnée par le prospect. Le choix et la forme de cet habillage confèrent au bâti une impression « d‘attique ». \nLa liaison entre les 2 corps de bâtiments est marquée par une grande terrasse traversante et accessible, vue depuis l'Avenue Jean-Baptiste Clément. Elle constitue le volume de transition entre les deux formes de bâti. \nLes matériaux choisis sont traditionnels, simples et robustes, aux teintes et aux matières naturellement contrastées mais sobres., Les ouvertures en façade, privilégient la verticalité et sont équipées de volets battants ou coulissants et s’harmonisent ainsi avec les constructions avoisinantes.  Les garde-corps des terrasses sont, soit pleins, soit en tôle découpée thermolaquée rappelant un motif végétal.",
        details: {
          mission: "Maîtrise d'œuvre de conception et suivi architectural (Livré Mars 2023)",
          surface: "1924 m²",
          cost: "2.6 M€ HT",
          client: "Angelotti Promotion",
          year: "En cours",
          performance: "RT 2012",
          duration: "14 mois",
          team: [
            "BET Structure : Per Ingénierie",
            "BET Fluides : Betso",
            "Géomètre  : RELIEF GE",
            "Bureau de contrôle : SOCOTEC"
          ]
        }
      },
      9: { // Le Chemin des Vignes
        subtitle: "Construction de 69 logements – Lotissement « Le chemin des Vignes » - Port la Nouvelle (11210)",
        shortDescription: "Grand ensemble résidentiel pensé comme un parc habité privilégiant espaces verts et convivialité.",
        fullDescription: "« Habiter dans un Parc ». \nA travers ce projet, nous avons recherché une unité du paysage pour permettre de percevoir le site comme une entité unique et préserver la quiétude des futurs occupants. \nNous avons travaillé particulièrement l’implantation des constructions et l’orientations des vues vers l'espace intérieur central et nous avons éloigné le bâti des pavillons avoisinants par l’interposition du parc de stationnement et une bande végétale arborée tout au long de la limite. \nNous avons privilégié les grandes transparences et continuités végétales en évitant les frontalités parallèles entre bâtis. \nTous les logements profiteront au maximum de vues sur les espaces verts de la résidence. Un jardin commun ou la nature a un rôle esthétique, pratique et nourricier, véritable lieu d’échange et de détente entre voisins. \nLe traitement des constructions vise à affirmer une unité architecturale et urbaine à travers le choix des matériaux, des teintes et de certains détails architecturaux qu’on retrouve sur les différentes façades, tout en affirmant des formes architecturales différenciées, en fonction des orientations, des vis-à-vis, des typologies, des besoins spécifiques.",
        details: {
          mission: "Maîtrise d'œuvre de conception et suivi architectural (DCE en cours)",
          surface: "4303 m²",
          cost: "7 M€ HT",
          client: "HABITAT AUDOIS",
          year: "En cours",
          duration: "20 mois",
          team: [
            "BET : DELORME",
            "BET : Cabinet DURAND",
            "BET : RELIEF GE",
            "BET : AZUR ENVIRONNEMENT",
            "Géomètre : ORRIT - BLANQUER",
            "Bureau de contrôle : SUD-EST PREVENTION"
          ],
          duration: "20 mois",
          performance: "RE2020"
        }
      },
      10: { // Maison individuelle Baillargues
        subtitle: "Maison individuelle – Quartier « Georges Bizet » à Baillargues (34670)",
        shortDescription: "Villa contemporaine méditerranéenne intégrée à son environnement naturel.",
        fullDescription: "Cette villa a été réalisée pour s’intégrer au site tout en respectant les codes méditerranéens. Elle est orientée plein sud et se développe longitudinalement selon l’axe E-O. Le jardin privatif fait le tour de la villa. \nL’ensemble de la construction s’articule autour d’un volume central à double hauteur abritant le séjour/salon, dont les grandes baies vitrées exposées Sud et la terrasse bois sont protégées par une généreuse pergola en bois et métal. \nLa volumétrie d’ensemble, de forme simple et homogène, a été conçue afin de conserver les masses végétales présentes sur le terrain. La toiture plate est végétalisée. \nL’angle NE de la villa, face à l’entrée, est marqué par un traitement en pierre naturelle rappelant le mur de clôture en pierre sèche dû par l’aménageur.",
        details: {
          mission: "Maîtrise d'œuvre de conception (Mission terminée)",
          surface: "128 m²",
          cost: "0.16 M€ HT",
          client: "Privé",
          duration: "6 mois",
          year: "Terminé",
          team: [
            "Géomètre : DEGEMA"
          ],
        }
      },
      11: { // Maison BBC Mondonville
        subtitle: "Maison individuelle passive en ossature bois à Mondonville (31700)",
        shortDescription: "Maison passive en ossature bois à haute performance énergétique.",
        fullDescription: "Cette maison a été construite en ossature bois et isolant naturel. Sa conception a respecté une cohérence dans l’enveloppe thermique, permettant à la maison de s’inscrire dans une démarche « énergie passive ». \nLa construction se développe toute en longueur. De plein pied et orientée plein sud, elle s’articule autour du volume d’entrée, au-dessus duquel nous avons créé une terrasse accessible. Cet élément, véritable « rotule » du bâtiment, constitue une « faille » qui permet à la fois, de séparer la zone nuit de la zone jour, d’avoir une vue traversante et un accès au grand jardin devant la maison, d'adapter l’orientation des volumes et de bénéficier ainsi de la meilleure orientation.  \nLes volumes se composent de formes simples et homogènes. La toiture monopente est tournée vers le jardin central afin de donner à ce lieu de vie un caractère intime et préservé. \nLe côté Nord, donnant sur la maison du voisin et le chemin d’accès, est occupé par les pièces moins nobles qui ne nécessitent pas d’ouvertures importantes. Le côté sud accueille les pièces de vie et les chambres qui profitent ainsi d’un ensoleillement maximal.",
        details: {
          mission: "Maîtrise d'œuvre de conception (Opération livrée)",
          surface: "130 m²",
          cost: "0.2 M€ HT",
          client: "Privé",
          year: "2016",
          duration: "8 mois",
          performance: "BBC",
          team: [
            "Géomètre : URBACTIS"
          ],
        }
      },
      12: { // Club House Baillargues
        subtitle: "Local associatif Club House et réfection des vestiaires du Stade à Baillargues (34670)",
        shortDescription: "Équipement sportif moderne alliant fonctionnalité et convivialité.",
        fullDescription: "La conception du local associatif du stade de Baillargues a permis d’harmoniser rénovation de la partie existante et extension. Un choix de matériaux nobles et durables tout en étant accessibles financièrement a facilité l’intégration du bâtiment dans son environnement sportif global. Le 1er objectif affiché ? Être un lieu d’accueil chaleureux et fonctionnel pour recevoir l’équipe du Brésil lors de la coupe du monde de football féminin en juillet 2019. Le second ? Que les nombreux clubs de la ville se l’approprient comme leur lieu de rencontre. Pari gagné si l’on en croit le taux d’utilisation de ces installations…",
        details: {
          mission: "Mission Complète + OPC (Opération livrée – mai 2018)",
          surface: "213 m²",
          cost: "0.15 M€ HT",
          client: "Ville de Baillargues",
          year: "2018",
          duration: "3 mois",
          team: [
            "BET Structure : SEGE Ingénierie",
            "Économiste : EXEOP", 
            "Bureaux de contrôle : QUALICONSULT"
          ]
        }
      },
      13: { // Poste Police Baillargues
        subtitle: "Réhabilitation de la « Maison Galibert » en Poste de Police Municipale à Baillargues (34670)",
        shortDescription: "Réhabilitation patrimoniale d'un bâtiment historique en équipement public moderne.",
        fullDescription: "Une police de proximité parfaitement intégrée au tissu local est un des gages principaux de son efficacité. La réhabilitation lourde d’un lieu d’habitation : la « Maison Galibert », pour y créer un poste de Police aux fonctionnalités modernes a prévalu aux différents travaux afin de pérenniser leur intégration architecturale en secteur protégé. \nAinsi, le bâtiment comprend le poste de contrôle et de supervision de vidéo-surveillance urbaine de la commune, les bureaux, les vestiaires sanitaires ainsi qu’un espace de détente pour les agents avec une zone d’accueil « public » à RDC. \nLe volume extérieur est conservé et restauré : réutilisation pour la pose en couvert des tuiles « canal » d’origine, conservation des moulures en façade, nouvelles gouttières en zinc vieilli.  \nDe plus, afin de conserver les dispositions traditionnelles, la façade a été décroutée puis enduite en trois couches à la chaux naturelle avec une couleur quasi identique à celle d’origine. \nLes menuiSEIRIes des fenêtres sont en bois peint de teinte grisée. Les volets bois sont quelques tons plus foncés.",
        details: {
          mission: "Mission Complète (Opération livrée – Juin 2021)",
          surface: "63 m²",
          cost: "0.16 M€ HT",
          client: "Ville de Baillargues",
          year: "2021",
          duration: "7 mois",
          team: [
            "BET Structure : Agi Technique",
            "DET + OPC : EXEOP",
            "Géomètre : SOLEA BTP",
            "Bureau de contrôle : ALPES CONTROLES",
          ]
        }
      },
      14: { // Stade René Franqués
        subtitle: "Maîtrise d’œuvre des installations sportives - Stade René Franqués à Florensac (34510)",
        shortDescription: "Équipement sportif moderne et dynamique à l'architecture contemporaine affirmée.",
        fullDescription: "Le projet, décidé par la Ville de Florensac, doit être un bâtiment à l’image de son usage : fonctionnel, dynamique, jeune et intemporel. \nLe bâtiment de plain-pied est travaillé en symétrie par rapport à l’axe central du terrain de football. De chaque côté se déploient : quatre vestiaires avec douches, les sanitaires, les bureaux et les locaux techniques. \nOn remarque très distinctement deux volumes bâtis accolés. Ils ont pour fonction d’offrir des accès indépendants entre les joueurs et le public, mais aussi de créer un jeu de volumes qui amplifie le côté dynamique et contemporain de l’architecture. \nLes tribunes de 207 places assises se déploient de chaque côté du tunnel d’accès au terrain depuis les vestiaires. \nTout en gardant une structure classique, les choix des couleurs, le jeu des accès au terrain et aux tribunes ainsi que l’auvent métallique, tel un totem, donnent une prestance et une assise au bâtiment.",
        details: {
          mission: "Mission Complète (Opération livrée – Décembre 2022)",
          surface: "445 m² + 164 m² (tribunes)",
          cost: "0.8 M€ HT",
          client: "Ville de Florensac",
          year: "2022",
          duration: "8 mois",
          team: [
            "BET Structure : Its",
            "BET Fluides : Cabinet DURAND",
            "Économiste : BPTEC",
            "DET + OPC : EXEOP",
            "Géomètre : BBAS",
            "Bureau de contrôle : SOCOTEC",
          ]
        }
      },
      15: { // ZAC Cambacérès
        subtitle: "ZAC CAMBACERES - Lot B.1.1 - Construction de 39 logements collectifs à Montpellier (34000)",
        shortDescription: "Projet de logements collectifs dans la ZAC Cambacérès",
        fullDescription: "Nous avons pensé notre projet comme une entité intégrée et en harmonie avec le paysage à la forte connotation naturelle et culturelle : « Une résidence dans le prolongement du Parc », avant-goût du grand Parc du Mas des Brousses situé en face. \nLe futur bâtiment s’articulera donc dans ce grand paysage rural, il fera la transition entre le parc et le nouveau quartier.",
        details: {
          mission: "Concours de maîtrise d'œuvre (Octobre 2018)",
          surface: "2756 m²",
          cost: "3 M€ HT (travaux) + 0.8 M€ HT (VRD)",
          client: "ACM HABITAT",
          year: "2018",
          architecteAssocie: "ARCHIZ",
          team: [
            "BET Structure : André VERDIER",
            "BET Fluides : Cabinet DURAND",
            "BET VRD : Cabinet SEIRI"
          ]
        }
      },
      16: { // 7 avenue de la Gardie Florensac
        subtitle: "Démolition et construction de 27 logements locatifs sociaux - 7, avenue de la Gardie – Florensac",
        shortDescription: "Renouvellement urbain avec construction de logements sociaux à Florensac",
        fullDescription: "Le parti général d’aménagement de la parcelle est basé sur l’organisation d’une nouvelle centralité proposant : \n- La création d’un « cœur d’îlot » à l’intérieur de la résidence et donc d’une nouvelle centralité pour ses futurs habitants ; \n- L’initiative d’une offre diversifiée en logements (petit collectif, villas superposées) ; \n- La création d’un poumon vert central dans la continuité des jardins potagers et vergers des parcelles avoisinantes. \nNotre projet, aux formes urbaines diversifiées, vient se greffer au tissu villageois tout en recherchant une connexion harmonieuse avec son environnement proche.",
        details: {
          mission: "Concours (Octobre 2020)",
          surface: "1910 m²",
          cost: "2.3 M€ HT",
          client: "Hérault-Logement",
          year: "2020",
          team: [
            "BET Structure : ITS 3.0",
            "BET Fluides : Cabinet DURAND",
            "BET VRD : Cabinet SEIRI",
            "Économie/MOEX/OPC : EXEOP"
          ]
        }
      },
      17: { // Secteur Martinet Langlade
        subtitle: "ZAC Cœur de Village - Construction de 39 logements \nSecteur Martinet à Commune de Langlade (30980)",
        shortDescription: "Quartier mixte d’habitat et de services au cœur du village de Langlade",
        fullDescription: "En cohérence avec les objectifs de la Commune, le projet présenté s’appuie sur une mixité de densité et une complémentarité des typologies de logements (collectif, villas groupées, maisons en partage et salle commune) venant se greffer au tissu villageois et pavillonnaire existant et encadrant la Place des Festivités (nouvelle centralité) contiguë aux futurs équipements publics.",
        details: {
          mission: "Concours (Novembre 2020)",
          surface: "3110 m²",
          client: "SPL AGATE",
          promoteur: "ANGELOTTI PROMOTION",
          bailleur: "UN TOIT POUR TOUS",
          year: "2020"
        }
      },
      18: { // Macro-lot C Garons
        subtitle: "Construction de 60 logements - Macro-lot C, ZAC Carrière des Amoureux à Garons (30128)",
        shortDescription: "Grand ensemble résidentiel dans la ZAC Carrière des Amoureux",
        fullDescription: "Nous avons recherché pour notre projet, une unité du paysage, une perception du site comme une entité unique. Un cadre de vie, serein et naturel pour ses futurs habitants. \nAinsi, nous avons créé deux corps de bâtiments qui s’articulent autour d’un cœur d’îlot central traversant, aéré, ponctué par les halls d’accès aux logements et les entrées privatives à RDC, très végétalisé. \nÀ l’échelle du piéton, cette disposition favorise la déambulation, la perméabilité des fonctions, offre des vues sur un paysage végétal présent et changeant en fonction des saisons, préserve de la monotonie, favorise l’appropriation des espaces extérieurs. ",
        details: {
          mission: "Concours (Novembre 2020)",
          surface: "3991 m²",
          client: "SPL AGATE",
          promoteur: "ANGELOTTI PROMOTION",
          bailleur: "UN TOIT POUR TOUS",
          year: "2020"
        }
      },
      19: { // Îlot Saint-Esprit Béziers
        subtitle: "Construction de 6 logements et un local commercial - Quartier du Capnau « Îlot Saint-Esprit » à Béziers (34500) ",
        shortDescription: "Programme mixte logements et commerce au cœur de Béziers",
        fullDescription: "Afin de conserver le caractère « stratégique » particulier de cet îlot, notre proposition a été pensée comme une « insertion signal » dont l’objet est de mettre en valeur le site au travers d’une architecture contemporaine et originale. Ceci afin de créer un lien entre la place de la Madeleine et l’entrée au quartier du Capnau, mais également de constituer un appel pour les visiteurs. \nPar la mise en relation des matières et des volumes nous avons recherché à la fois une confrontation et une réconciliation du passé et du présent, une connexion entre la ville « historique » et une expression plus contemporaine, une composition géométrique épurée, simple et audacieuse.",
        details: {
          mission: "Concours (Octobre 2019)",
          surface: "268 m² (logements) + 75 m² (commerces)",
          client: "Ville de Béziers",
          promoteur: "ANGELOTTI PROMOTION / PROMO G",
          year: "2019"
        }
      },
      20: { // Macro-lot A Garons
        subtitle: "Construction de 52 logements - Macro-lot A, ZAC Carrière des Amoureux à Garons (30128)",
        shortDescription: "Ensemble résidentiel dans la ZAC Carrière des Amoureux",
        fullDescription: "Notre projet propose un mode « d’habiter » le grand paysage, où les constructions ont une relation privilégiée avec le paysage environnant, les bassins de rétention, les jardins potagers et les espaces végétales de la résidence. \nLe paysage est considéré comme une ressource qui profite à chaque logement, à chaque habitant. \nPar conséquent, ce projet inclu toutes ces contraintes techniques : ne pas refermer les constructions sur elles-mêmes, ouvrir les logements généreusement sur le paysage omniprésent, respecter la qualité des espaces partagés, inciter l’usage de mode de mobilité douce, construire l’architecture avec les qualités de son territoire en favorisant les filières locales de construction. La notion de grand paysage peut s’apprécier à la fois à l’échelle de son logement (de chez moi), de son jardin, depuis la placette d’îlot mais aussi depuis le mail piétonnier central ou bien même depuis la voie publique.",
        details: {
          mission: "Concours (Novembre 2020)",
          surface: "2797 m²",
          client: "SPL AGATE",
          promoteur: "ANGELOTTI PROMOTION",
          bailleur: "UN TOIT POUR TOUS",
          year: "2020"
        }
      },
      21: { // ZAC Puits de Roulle Nîmes
        subtitle: "ZAC « Puits de Roulle » - Lot 7 - Nîmes - Construction de 34 logements",
        shortDescription: "Programme résidentiel dans la ZAC Puits de Roulle à Nîmes",
        fullDescription: "Projet de construction de 34 logements dans le Lot 7 de la ZAC « Puits de Roulle » à Nîmes. Un programme parfaitement intégré au paysage et qui épouse la topographie du terrain. \nLe projet s’inscrit dans le périmètre de la ZAC du Puits de Roulle. \nIl s’articule autour des principes suivants : \n- Un aménagement respectueux de la topographie naturelle du terrain \n- La préservation du patrimoine végétal existant \nUne architecture inspirée au thème de la « nature méditerranéenne ».",
        details: {
          mission: "Concours (Novembre 2021)",
          surface: "2208 m²",
          client: "Ville de Nîmes",
          promoteur: "ENVOL",
          year: "2021"
        }
      },
      22: { // Étude Concept - Microstation dédiée (GAZ GNV)
        subtitle: "Concept totalement novateur de station-service à destination des particuliers.",
        shortDescription: "Concept totalement novateur de station-service à destination des particuliers.",
        fullDescription: "Le groupe SEVEN (entreprise qui investit, développe, construit et exploite en France plus de 15 stations « vertes multi énergies pour le transport routier) a souhaité adresser un nouveau marché : celui des véhicules légers fonctionnant au bio Gaz ou à l’hydrogène. Son Président a fait appel à nous pour imaginer un concept totalement novateur de station-service à destination des particuliers. L’objectif était de construire des microstations à un coût modéré grâce à une standardisation du bâti construit en usine tout en minimisant les interventions terrain de construction et en facilitant la maintenance des équipements techniques. La solution que nous avons proposée a ainsi allié esthétique (ligne élancée et moderne), praticité pour le client comme pour le propriétaire de la station, reproductibilité à coûts maîtrisés tout en conservant l’adaptabilité à divers types de véhicules ciblés (longueurs), aux spécifications techniques et aux configurations du terrain.",
        details: {
          mission: "Étude prototype",
          client: "SEVEN",
          year: "2018",
          promoteur: "MO : SEVEN OCCITANIE"
        }
      },
      23: { // Cité des Peupliers à Narbonne
        subtitle: "Réalisation d’un programme immobilier de 50 logements – Cité des Peupliers à Narbonne (11100)",
        shortDescription: "Programme immobilier de 50 logements dans la Cité des Peupliers à Narbonne",
        fullDescription: "Appel à candidature dans le cadre de la cession de foncier pour la réalisation d’un programme immobilier - 8 rue des Peupliers à Narbonne. \nLe projet a vocation à intégrer les dimensions du développement durable et à favoriser la biodiversité, notamment grâce au renforcement d’une véritable trame verte et bleue.  \nLa création d’espaces communs partagés, favorisant le lien social et contribuant au changement d’image du quartier est l’un des enjeux du projet. La réalisation d’un maillage piétonnier et le développement des modes de déplacements doux, participeront à l’ouverture du quartier.",
        details: {
          mission: "Concours (Mars 2023)",
          surface: "2208 m²",
          client: "Ville de Narbonne",
          promoteur: "ENVOL",
          year: "2023",
          cost: "2.3 M€ HT",
        }
      },
    },
    projectDescriptions: {
      1: "Résidence moderne de 48 logements collectifs intégrant des espaces verts et des équipements partagés.",
      2: "Programme immobilier innovant au cœur du quartier Ovalie, privilégiant la qualité de vie et l'efficacité énergétique.",
      3: "Ensemble résidentiel contemporain alliant architecture épurée et confort de vie en centre-ville.",
      4: "Réhabilitation urbaine respectueuse du patrimoine local, créant un dialogue entre tradition et modernité.",
      5: "Projet de logements collectifs éco-responsables avec jardins partagés et espaces communs végétalisés.",
      6: "Architecture méditerranéenne contemporaine s'inspirant du terroir viticole local.",
      7: "Ensemble de logements s'intégrant harmonieusement dans le tissu urbain existant.",
      8: "Programme de logements au centre-ville alliant tradition et modernité architecturale.",
      9: "Grand ensemble résidentiel pensé comme un parc habité privilégiant espaces verts et convivialité.",
      10: "Villa contemporaine méditerranéenne intégrée à son environnement naturel.",
      11: "Maison passive en ossature bois à haute performance énergétique.",
      12: "Équipement sportif moderne alliant fonctionnalité et convivialité.",
      13: "Réhabilitation patrimoniale d'un bâtiment historique en équipement public moderne.",
      14: "Équipement sportif moderne et dynamique à l'architecture contemporaine affirmée.",
      15: "Projet de logements collectifs dans la ZAC Cambacérès.",
      16: "Développement résidentiel au cœur du village de Florensac.",
      17: "Quartier mixte d’habitat et de services au cœur du village de Langlade.",
      18: "Grand ensemble résidentiel dans la ZAC Carrière des Amoureux.",
      19: "Programme mixte logements et commerce au cœur de Béziers.",
      20: "Ensemble résidentiel dans la ZAC Carrière des Amoureux.",
      21: "Programme résidentiel dans la ZAC Puits de Roulle à Nîmes.",
      22: "Concept totalement novateur de station-service à destination des particuliers.",
      23: "Programme immobilier de 50 logements dans la Cité des Peupliers à Narbonne."
    },
    projectDetail: {
      // En-tête
      backToProjects: "Retour aux projets",
      
      // Sections
      description: "Description",
      informations: "Informations",
      
      // Champs d'information
      mission: "Mission",
      surface: "Surface",
      cost: "Coût",
      client: "Client",
      year: "Année",
      team: "Équipe",
      architecteAssocie: "Architecte Associé",
      promoteur: "Promoteur",
      bailleur: "Bailleur Social",
      duration: "Durée des travaux",
      performance: "Performance énergétique",
      
      // Messages
      notFound: "Projet non trouvé",
      noDescription: "Description non disponible"
    },
    news: {
      title: 'Actualités',
      subtitle: 'Suivez nos derniers projets et réalisations',
      readArticle: 'Lire l\'article',
      viewPdf: 'Voir le PDF',
      viewImage: 'Voir l\'image',
      expand: 'Agrandir',
      noNews: 'Aucune actualité pour le moment.'
    },

    cityPage: {
      region: "Hérault (34) — Occitanie",
      heroTitle: "Architecte à",
      heroSubtitle: "Cabinet Daniela Parito Architecture — 30 ans d'expérience dans l'Hérault",
      ctaQuote: "Demander un devis gratuit",
      ctaProjects: "Voir nos réalisations",
      introTitle: "DP Architecture à",
      statExp: "ans d'expérience",
      statProjects: "projets livrés",
      statCert: "expertise certifiée",
      servicesTitle: "Nos services à",
      servicesAnd: "et dans l'Hérault",
      servicesIntro: "Daniela Parito Architecture intervient sur l'ensemble des typologies architecturales dans le département de l'Hérault.",
      service1Title: "Habitat Collectif",
      service1Items: [
        "Logements collectifs et résidences",
        "Habitat intermédiaire et groupé",
        "Conformité RE2020 et BBC",
        "Intégration urbaine et paysagère"
      ],
      service2Title: "Habitat Individuel",
      service2Items: [
        "Villas contemporaines sur mesure",
        "Maisons passives et BBC",
        "Extensions et rénovations",
        "Architecture méditerranéenne"
      ],
      service3Title: "Tertiaire & Équipements",
      service3Items: [
        "Études urbaines et ZAC",
        "Équipements publics (ERP)",
        "Bâtiments administratifs",
        "Équipements sportifs et culturels"
      ],
      projectsLocalTitle: "Nos réalisations à",
      projectsLocalAnd: "et à proximité",
      projectsNearbyTitle: "Nos réalisations à proximité de",
      projectsIntro: "Découvrez nos projets de référence dans votre secteur.",
      projectsCta: "Voir tous nos projets",
      whyTitle: "Pourquoi choisir DP Architecture à",
      why1Title: "Architecte inscrite à l'Ordre",
      why1Text: "Daniela Parito Sorrenti, architecte diplômée de Rome, possède 30 ans d'expérience en conception architecturale complexe et gestion de projets en Occitanie.",
      why2Title: "Expertise RE2020 & BBC",
      why2TextA: "Maîtrise complète des normes environnementales les plus exigeantes : RE2020, BBC, bâtiment passif et HQE. Vos projets à",
      why2TextB: "bénéficieront des meilleures performances énergétiques.",
      why3Title: "Ancrage local Hérault",
      why3Text: "Basé à Montpellier depuis 2014, le cabinet DP Architecture intervient dans tout le département de l'Hérault et connaît parfaitement les contraintes réglementaires et paysagères locales.",
      why4Title: "Respect des budgets",
      why4Text: "Engagement ferme sur le respect des enveloppes budgétaires. Chaque projet fait l'objet d'un suivi rigoureux des coûts, de la conception à la livraison.",
      ctaTitle: "Votre projet à",
      ctaTitleEnd: "? Parlons-en !",
      ctaText1: "Contactez Daniela Parito Architecture pour une première consultation gratuite. Nous intervenons à",
      ctaText2: "et dans tout le département de l'Hérault (34).",
      ctaSend: "Envoyer un message"
    },

    articlePage: {
      backToNews: "Retour aux actualités",
      inlineCtaText: "Vous avez un projet dans l'Hérault ?",
      inlineCtaBtn: "Contactez DP Architecture",
      sidebarContactTitle: "Votre projet dans l'Hérault",
      sidebarContactText: "Daniela Parito Architecture intervient dans tout le département de l'Hérault.",
      sidebarQuote: "Devis gratuit",
      sidebarRelatedTitle: "À lire aussi",
      sidebarCitiesTitle: "Nous intervenons à"
    },

    newsData: [
      {
        id: 1,
        date: 'Octobre 2019',
        category: 'Livraison',
        title: 'Résidence Park View - ZAC Ovalie, Montpellier',
        excerpt: 'Livraison de la résidence Park View, 32 logements en accession libre dans le quartier Ovalie à Montpellier. Un projet qui privilégie l\'exposition et les vues sur le parc du Rieucoulon.'
      },
      {
        id: 2,
        date: 'Octobre 2019',
        category: 'Article',
        title: 'COGIM - Résidence Park View dans la presse',
        excerpt: 'Article de presse présentant la résidence Park View réalisée pour COGIM dans le quartier Ovalie. Une architecture contemporaine qui dialogue avec son environnement.'
      },
      {
        id: 3,
        date: 'Mai 2019',
        category: 'Article',
        title: 'Baillargues prêt à accueillir les joueuses de la Coupe du monde de football féminin',
        excerpt: 'Article de presse présentant la restructuration du bâtiment des vestiaires du club de football à Baillargues. Des travaux permettant la création d\'un club dédié de 50 m².'
      },
      {
        id: 7,
        date: "Mai 2026",
        category: "Urbanisme",
        title: "ZAN dans l'Hérault : comment bâtir quand le foncier se raréfie",
        excerpt: "Le Zéro Artificialisation Nette redessine la construction dans l'Hérault. Moins de foncier en extension, priorité au renouvellement urbain et à la réhabilitation : voici ce que cela change concrètement pour vos projets, et le rôle de l'architecte pour bâtir dense et qualitatif."
      },
      {
        id: 8,
        date: "Avril 2026",
        category: "Expertise",
        title: "Architecture bioclimatique méditerranéenne : rester au frais sans climatisation dans l'Hérault",
        excerpt: "Dans l'Hérault, en zone climatique H3, l'été met les logements à l'épreuve. La conception bioclimatique méditerranéenne permet de garder une maison fraîche sans climatisation, tout en répondant aux seuils de confort d'été de la RE2020. DP Architecture vous explique les leviers concrets."
      },
      {
        id: 9,
        date: "Mars 2026",
        category: "Conseils",
        title: "Passoires thermiques dans l'Hérault : comprendre le calendrier et réussir sa rénovation énergétique",
        excerpt: "Interdiction de louer les DPE G, F puis E : le calendrier des passoires thermiques se précise. Voici ce que cela implique pour les propriétaires et bailleurs de l'Hérault, et le rôle de l'architecte dans une rénovation énergétique d'ampleur."
      },
      {
        id: 4,
        date: 'Janvier 2025',
        category: 'Expertise',
        title: 'La RE2020 en Hérault : construire durable avec un architecte expert',
        excerpt: 'La réglementation environnementale 2020 transforme profondément les pratiques architecturales. Découvrez comment DP Architecture vous accompagne dans vos projets durables en Hérault.'
      },
      {
        id: 5,
        date: 'Novembre 2024',
        category: 'Réalisations',
        title: 'Logements collectifs à Montpellier et dans l\'Hérault : 30 ans d\'expertise',
        excerpt: 'DP Architecture est un acteur reconnu de la construction de logements collectifs dans l\'Hérault. Retour sur 30 ans de réalisations entre Montpellier, Mauguio, Florensac et l\'agglomération héraultaise.'
      },
      {
        id: 6,
        date: 'Septembre 2024',
        category: 'Conseils',
        title: 'Construire votre maison individuelle dans l\'Hérault avec un architecte',
        excerpt: 'Faire appel à un architecte pour votre maison individuelle dans l\'Hérault, c\'est choisir un accompagnement sur mesure, une garantie de qualité et une expertise en architecture méditerranéenne contemporaine.'
      }
    ],
  },


  /////////////
  // ENGLISH //
  /////////////
  en: {
    nav: {
      home: 'Home',
      agency: 'Agency',
      projects: 'Projects',
      missions: 'Services',
      contact: 'Contact',
      news: 'News'
    },

    home: {
      title: 'Mediterranean architecture in Montpellier',
      subtitle: 'Create spaces that inspire you',
      discover: 'View our projects',
      startProject: 'Start a project',

      // Section Expertise/USP
      expertise: {
        title: 'Your vision, our expertise',
        intro:
          "An architecture studio based in Montpellier, we support public and private projects with a bespoke approach combining creativity, energy performance and respect for the environment.",

        usp1: {
          title: '30+ years of experience',
          text: 'Proven expertise in multi-family housing, single-family homes and territorial planning'
        },
        usp2: {
          title: 'Bespoke approach',
          text: 'Every project is unique and designed to respect your vision and your environment'
        },
        usp3: {
          title: 'Energy performance',
          text: 'RE2020, BBC, passive buildings: we integrate the latest environmental standards'
        },

        cta: 'Learn more about the agency'
      },

      // Section Projets phares
      featured: {
        title: 'Completed projects',
        intro:
          'Discover our recent work in multi-family housing, single-family homes and urban development',
        viewProject: 'View project',
        cta: 'View all projects'
      },

      // Section Processus
      process: {
        title: 'Our support',
        intro: 'A clear, collaborative process from first contact to handover',

        step1: {
          title: 'Listening & Analysis',
          text:
            'We assess your needs, constraints and goals to define the ideal project together'
        },
        step2: {
          title: 'Design',
          text:
            'Concept, schematic design, detailed design: we create an architectural proposal tailored to your needs and the site'
        },
        step3: {
          title: 'Construction supervision',
          text:
            'Technical support and project coordination to ensure compliance and quality execution'
        },
        step4: {
          title: 'Handover',
          text:
            'Final acceptance and guidance to ensure a smooth transition into your building'
        }
      },

      // Section Services
      services: {
        title: 'Our areas of expertise',

        collective: {
          title: 'Multi-family housing',
          text: 'Social housing, residences, energy performance (RE2020/BBC)',
          link: 'Learn more'
        },
        individual: {
          title: 'Single-family homes',
          text: 'Bespoke houses, passive villas, extensions and renovations',
          link: 'Learn more'
        },
        territory: {
          title: 'Territorial planning',
          text: 'Urban studies, ZAC developments, public facilities, space renewal',
          link: 'Learn more'
        }
      },

      // CTA finale
      ctaFinal: {
        title: 'Ready to bring your project to life?',
        text:
          'Whether you are an individual, a developer or a local authority, we’re here to turn your vision into reality.',
        contact: 'Contact us',
        projects: 'View our work'
      }
    },

    agency: {
      title: 'Architect in Montpellier',
      presentation: 'Overview',
      society: 'The Company',
      philosophy: 'Our Philosophy',
      team: 'The Team',
      partners: 'Key partners',
      bet: 'Engineering Design Offices (BET)',
      structure: 'Structure',
      fluides: 'MEP (Building services)',
      geometre: 'Surveyor',
      desamiantage: 'Asbestos removal',

      logiciels: 'Main software used',

      tagline:
        'Contemporary architecture — the agency brings over 30 years of experience in architectural design and complex project management.',

      presentationText:
        'Daniela Parito Architecture brings together architects and partners, with its main fields of activity in multi-family and single-family housing, both new-build and refurbishment, as well as public-access buildings (ERP). The agency has won several public competitions and developer consultations on behalf of social landlords, developers and local authorities. In parallel, it has carried out studies and delivered restructuring and construction projects for private clients.',

      philosophyText:
        "Our approach prioritizes architectural quality, respect for the environment and innovation. Each project is conceived as a unique response to its context, constraints and ambitions. Listening and dialogue before and throughout the project, established with clients and technical partners, are the foundation of our quality-driven process. Our priority: user comfort, while ensuring seamless urban integration and strict adherence to the budget.",
      philosophyText2:
        'Understanding a project to find the perfectly integrated and adapted solution is also my vision of Mediterranean architecture.',

      societyText:
        'Founded in October 2014 by its current managing director, Daniela PARITO, the agency initially focused on taking over in Montpellier several project studies and construction operations for private and public housing. Daniela Parito Architecture brings together architects and partners, with its main field of activity in multi-family and single-family housing, both new-build and refurbishment, as well as public-access buildings (ERP). The individualized approach to use and aesthetics, the contemporary architectural language of each project, consideration of environmental and legal constraints, and budget compliance are major strengths of the agency and recognized by its clients.',

      collaborationIntro: {
        paragraph1:
          'The success of an architectural project requires a simple and direct approach at every level—both in relations among the project team and with the client, as well as with institutional stakeholders.',
        paragraph2:
          'Depending on each project’s specificities and the design phases, the agency works with specialized external consultants with whom it collaborates. In this way, the agency continuously benefits from shared practices and cross-disciplinary perspectives.',
        paragraph3:
          'This flexible way of working forms a dynamic, experienced team, enabling us to meet the client’s needs with quality and rigor, while respecting deadlines.'
      },

      teamMembers: [
        {
          name: 'Daniela PARITO SORRENTI',
          role: 'Architect & CEO',
          bio:
            'Founder of the agency, Daniela PARITO brings over 30 years of experience in architectural design and complex project management.',
          summary:
            "Graduated from the Faculty of Architecture and Urban Planning of Rome (Doctorate, 1990), Daniela PARITO founded her agency in Montpellier in 2014 after 24 years of experience in leading Parisian and regional firms. Specializing in multi-family and single-family housing as well as public facilities, she combines technical expertise, Mediterranean sensitivity and a commitment to sustainable, human-centered architecture."
        }
      ]
    },

    projects: {
      title: 'Our projects in the Hérault',
      all: 'View all projects',
      collective: 'Multi-family Housing',
      individual: 'Single-family Housing',
      territory: 'Tertiary',
      competitions: 'Competitions',
      viewProject: 'View project'
    },

    missions: {
      title: 'Our architecture services',
      subtitle: 'Benefit from tailored expertise and support backed by our 30 years of experience.',
      
      // Introduction
      intro: "For over 30 years, Daniela Parito Architecture has been supporting clients in the design and delivery of large-scale architectural projects. Our expertise covers the entire project lifecycle, from initial sketches to final delivery, including site supervision and team coordination.",
      
      // Types of missions
      types: [
        {
          title: 'Architectural Design',
          description: 'From concept to completion, we develop bespoke projects tailored to your needs and constraints.',
          highlights: [
            'Feasibility studies and programming',
            'Architectural design (preliminary, detailed, tender)',
            'Contract procurement assistance',
            'Site supervision and project coordination'
          ]
        },
        {
          title: 'Multi-Family Housing',
          description: 'Design of residential complexes combining quality of life, energy performance and urban integration.',
          highlights: [
            'Social and affordable housing',
            'Private residential developments',
            'Energy performance (RE2020, low-energy)',
            'Urban and landscape integration'
          ]
        },
        {
          title: 'Single-Family Homes',
          description: 'Contemporary houses designed for your lifestyle, in harmony with their surroundings.',
          highlights: [
            'Custom contemporary homes',
            'Passive and low-energy villas',
            'Extensions and renovations',
            'Mediterranean architecture'
          ]
        },
        {
          title: 'Tertiary',
          description: 'Design and delivery of public facilities. Functionality and aesthetics serving future users.',
          highlights: [
            'Public facilities (ERP)',
            'Administrative buildings',
            'Rehabilitations and compliance upgrades',
            'Sports and cultural facilities'
          ]
        }
      ],
      
      // Project phases
      phases: {
        studies: {
          title: 'Design Phase',
          content: [
            'Studies will take into account the specific nature of the project, including its urban and landscape setting, analysis of applicable zoning regulations, energy efficiency requirements related to RE2020 certification, and the objectives set by the Client.',
            'We will focus on energy performance, quality of space usage, air quality and acoustic comfort, proposing the optimal technical and environmental solution while respecting the project\'s target budget.'
          ]
        },
        works: {
          title: 'Construction Phase',
          subsections: [
            {
              title: 'Site Preparation',
              content: [
                'During the preparatory phase, the main tasks of the project management team will include finalising all interventions covered by the contractors\' agreements, managing timelines, planning works, and providing the Client with regular updates on project progress.'
              ]
            },
            {
              title: 'Construction Execution',
              content: [
                'During the construction phase, the key priorities for the project management team are deadline management and nuisance control, compliance with technical regulations, and cost management.',
                'Throughout the works, our team will regularly monitor the quality and compliance of the construction and keep the Client informed.'
              ]
            },
            {
              title: 'Project Handover',
              content: [
                'As part of the pre-handover operations, each member of the project management team, within their area of expertise and in constant consultation, will be responsible for verifying and analysing the compliance of completed works and any outstanding items.',
                'Prior to commissioning, a meeting will be organised with the project management team for users and occupants, to inform them of equipment specifications and ensure that their operation maintains the quality and proper functioning of the facilities.'
              ]
            }
          ]
        },
        greenSite: {
          title: 'Green Construction Site',
          content: [
            'Environmental Site Management is a key element for ensuring quality in the execution of works.',
            'We will work to minimise the impact of nuisances on site operations in terms of safety, cleanliness, and maintaining the level of excellence in works carried out by each contractor.'
          ]
        },
        landscape: {
          title: 'Landscape Integration',
          content: [
            'The treatment of outdoor spaces is also at the heart of our approach.',
            'We will work on optimising access routes, creating soft mobility paths, greening spaces, and preserving and developing local flora and fauna to deliver "architecture that respects its environment".'
          ]
        }
      },
      
      // "Our approach" section
      approach: {
        title: 'Our Commitments',
        details: [
          {
            title: 'Express a strong, intentional and sensitive architectural vision, without excess',
            description: 'Quality listening and dialogue before and during the project, established with clients and technical partners, is the foundation of our quality approach.'
          },
          {
            title: 'Create quality living spaces and environments defined above all by the user',
            description: 'Every proposal serves user quality and comfort while ensuring perfect urban integration and strict adherence to budget.'
          },
          {
            title: 'Reveal a concept with an approach mindful of context, built environment and landscape',
            description: 'The practice bases its thinking on architectural coherence specific to each project: from small-scale interventions to major urban developments.'
          },
          {
            title: 'Design projects in harmony with their environment and relevant in terms of High Environmental Quality',
            description: 'The practice\'s environmental commitment is reflected in promoting short supply chains for construction materials, an overall focus on energy savings in use, and optimising resources in building construction.'
          }
        ],
        items: [
          {
            title: 'Technical-Environmental Balance',
            description: 'Seeking the best technical-environmental balance while respecting the project\'s target budget.'
          },
          {
            title: 'Optimisation Through Simulation',
            description: 'Optimising proposed solutions using specialised simulation tools to ensure the performance and feasibility of each project.'
          },
          {
            title: 'Project Management',
            description: 'Ensuring project quality monitoring through the use of a project management system throughout the entire operation.'
          },
          {
            title: 'Collaborative Approach',
            description: 'Attentive listening and constant dialogue with clients and technical partners, from design to delivery.'
          }
        ]
      }
    },

    contact: {
      title: 'Contact',
      name: 'Name',
      email: 'Email',
      message: 'Message',
      send: 'Send',
      sending: 'Sending...',
      success: 'Your message has been sent successfully!',
      error: 'An error occurred. Please try again.',
      info: 'Contact Information',
      address: '663 rue du pré aux clercs',
      city: '34000 Montpellier, France',
      consentText: 'I agree that my data may be used to process my request, in accordance with the',
      consentLink: 'privacy policy'
    },

    news: {
      title: 'Our news',
      subtitle: 'Follow our latest projects and achievements',
      readArticle: 'Read the article',
      viewPdf: 'View the PDF',
      viewImage: 'View the image',
      expand: 'Enlarge',
      noNews: 'No news at the moment.'
    },

    bio: {
      formations: {
        title: 'Education',
        list: [
          "Doctorate in Architecture D.F.A.U.R. (Faculty of Architecture and Urban Planning of Rome – 1990)",
          "State qualification to practice as an Architect (Rome – 1996)",
          'DU Construction Site Management (Montpellier – 2001)',
          'CSPS - Level 1 (Montpellier – 2001)',
          'Energy renovation of single-family homes (Montpellier – 2020)',
          "Registered with the Order of Architects – Occitanie Region under Order No. 046166",
          "Registered with the Order of Architects – Occitanie Region under Order No. S16988"
        ]
      },

      logementsNeufs: {
        title: 'New Housing',
        concoursTitle: 'Award-winning competitions',
        projetsTitle: 'Projects',

        concours: [
          {
            title:
              'Demolition of 49 and construction of 50 social housing units – Florensac (34510)',
            subtitle: 'Cité Marcadal – Avenue de la Gardie',
            details: [
              'Lead architect: Daniela PARITO Architecture',
              'Associate architect: ARCHIZ',
              'GFA: 3643 m² // Estimated budget: €5,807,700 excl. VAT',
              'Client: HÉRAULT–LOGEMENT',
              'Full service (Phase 3 – construction in progress)'
            ]
          },
          {
            title:
              'Design–Build of 48 social housing units – ZAC Pierres Vives - Montpellier (34000)',
            subtitle: 'Alfred Screve Residence – Rue Marius Petipa',
            details: [
              'Consortium lead: GIRAUD MIDI-PYRÉNÉES',
              'Lead architect: Daniela PARITO Architecture',
              'Associate architect: R+C2',
              'GFA: 3391 m² // Budget: €4,344,000 excl. VAT',
              'Client: HÉRAULT–HABITAT',
              'Full service (Delivered – 2020)'
            ]
          },
          {
            title:
              'Construction of 20 social housing units – Maraussan (34370)',
            subtitle: 'Les Semailles Residence',
            details: [
              'GFA: 1288 m² // Budget: €1,900,000 excl. VAT',
              'Client: HÉRAULT–HABITAT',
              'Full service (Delivered – September 2018)'
            ]
          }
        ],

        projets: [
          {
            title:
              'Construction of a 36-home residence and one home for shared living for 6 people with disabilities – Beaucaire (30300)',
            details: [
              'GFA: 2669 m² // Budget: €4,200,000 excl. VAT',
              'Client: EDOUARD DENIS',
              'Design leadership and architectural supervision (Studies in progress)'
            ]
          },
          {
            title:
              'Construction of 69 homes – “Le Chemin des Vignes” subdivision - Port-la-Nouvelle (11210)',
            subtitle: 'Le Corail Residence',
            details: [
              'GFA: 4303 m² // Budget: €7,000,000 excl. VAT',
              'Client: HABITAT AUDOIS',
              'Design leadership and architectural supervision (Tender documents in progress)'
            ]
          },
          {
            title: 'Construction of 30 homes – Narbonne (11100)',
            details: [
              'GFA: 2158 m²',
              'Client: ENVOL',
              'Design leadership and architectural supervision (Studies in progress)'
            ]
          },
          {
            title: 'Construction of 24 homes – Frontignan (34110)',
            details: [
              'GFA: 1621 m² // Budget: €2,000,000 excl. VAT',
              'Client: IDEOM',
              'Design leadership and architectural supervision (Project discontinued)'
            ]
          },
          {
            title:
              'Construction of 34 homes incl. 11 subsidized units – Patio Clément Residence - Mauguio (34130)',
            details: [
              'GFA: 2139 m² // Budget: €2,600,000 excl. VAT',
              'Client: ANGELOTTI PROMOTION',
              'Design leadership and architectural supervision (Delivered – March 2023)'
            ]
          },
          {
            title:
              'Demolition of the former cooperative winery and construction of 26 social housing units – Maureilhan (34370)',
            subtitle: 'La Vigneronne Residence',
            details: [
              'GFA: 1666 m² // Budget: €2,128,182 excl. VAT',
              'Client: FDI HABITAT',
              'Full service (Delivered – July 2022)'
            ]
          },
          {
            title:
              'Construction of 20 subsidized housing units – Pélissier Residence - Mauguio (34130)',
            details: [
              'GFA: 1460 m² // Budget: €1,400,000 excl. VAT',
              'Client: AMETIS',
              'Design leadership and architectural supervision (Delivered – August 2022)'
            ]
          },
          {
            title:
              'Construction of 32 owner-occupied homes – Park View Residence - ZAC Ovalie, Lot 23 C2, Montpellier',
            details: [
              'GFA: 1809 m² // Budget: €2,450,000 excl. VAT',
              'Client: COGIM / LES VILLÉGIALES',
              'Design leadership and architectural supervision (Delivered – September 2019)'
            ]
          }
        ]
      },

      tertiaire: {
        title: 'Tertiary',
        projets: [
          {
            title:
              'Rehabilitation of Maison Galibert into a Municipal Police Station - Baillargues (34670)',
            details: [
              'NFA: 63 m² // Budget: €160,500 excl. VAT',
              'Client: TOWN OF BAILLARGUES',
              'Full service (Delivered – June 2021)'
            ]
          },
          {
            title:
              'Renovation of Stade René Franques – Sports facilities design team - Florensac (34510)',
            details: [
              'NFA: 445 m² + 164 m² (stands) // Budget: €816,000 excl. VAT',
              'Client: TOWN OF FLORENSAC',
              'Full service (Delivered – December 2022)'
            ]
          },
          {
            title:
              'Extension of the community facility (Club House) and renovation of the stadium changing rooms - Baillargues (34670)',
            details: [
              'NFA: 213 m² incl. 30 m² extension // Budget: €148,202 excl. VAT',
              'Client: TOWN OF BAILLARGUES',
              'Full service (Delivered – May 2018)'
            ]
          },
          {
            title: 'Concept: dedicated microstation (CNG)',
            details: ['Client: SEVEN OCCITANIE', 'Prototype study (June 2018)']
          }
        ]
      },

      logementsIndividuels: {
        title: 'Single-family Homes',
        projets: [
          {
            title: 'Extension of a single-family home - Chameyrat (19330)',
            details:
              'Created floor area: 60 m² // Budget: €80,000 excl. VAT // Design services (Mission completed)'
          },
          {
            title: 'Single-family home - Argelliers (34380)',
            details:
              'GFA: 222 m² // Budget: €500,000 excl. VAT // Design services (Mission completed)'
          },
          {
            title:
              'Single-family home – “Georges Bizet” neighborhood - Baillargues (34670)',
            details:
              'GFA: 130 m² // Budget: €160,000 excl. VAT // Design services (Mission completed)'
          },
          {
            title: 'Restructuring of a villa – Saint-Aunés (34130)',
            details: 'Budget: €140,000 excl. VAT // Full service (Delivered)'
          },
          {
            title: 'Extension of an apartment – Le Crès (34920)',
            details:
              'GFA: 50 m² // Budget: €100,000 excl. VAT // Design services (Mission completed)'
          },
          {
            title: 'Passive timber-frame single-family home - Mondonville (31700)',
            details:
              'GFA: 130 m² // Budget: €300,000 excl. VAT // Design services (Mission completed)'
          },
          {
            title: 'Extension of a home – Salina (Italy)',
            details:
              'GFA: 60 m² // Budget: €100,000 excl. VAT // Design services (Mission completed)'
          },
          {
            title: 'Restructuring of a townhouse – Montpellier',
            details: 'GFA: 108 m² // Budget: €200,000 excl. VAT // Full service (Delivered)'
          }
        ]
      },

      concours: {
        title: 'Competitions & Developer Consultations',
        projets: [
          {
            title:
              'Delivery of a 50-home residential program – Cité des Peupliers - Narbonne (11100)',
            details:
              'GFA: 3481 m² // Estimated budget: €5,500,000 excl. VAT // Client: City of Narbonne // Developer: ENVOL'
          },
          {
            title:
              'ZAC “Puits de Roulle” - Lot 7 - Construction of 34 homes – Nîmes (30900)',
            details: 'GFA: 2208 m² // Client: City of Nîmes // Developer: ENVOL'
          },
          {
            title:
              'Demolition and construction of 27 social rental homes - Florensac (34510)',
            details:
              'GFA: 1910 m² // Estimated budget: €2,292,000 excl. VAT // Client: HÉRAULT-LOGEMENT'
          },
          {
            title:
              'Construction of 45 homes – MARTINET sector “Cœur de Village” - Langlade (30980)',
            details: 'GFA: 3110 m² // Client: SPL AGATE // Developer: ANGELOTTI PROMOTION'
          },
          {
            title: 'Construction of 6 homes + ground-floor shops – Béziers (34500)',
            details:
              'NLA: 268 m² - NFA: 75 m² // Client: City of Béziers // Developer: ANGELOTTI PROMOTION – PROMO G'
          },
          {
            title:
              'Construction of 39 multi-family homes – ZAC Cambacérès – Lot B 1.1 – Montpellier',
            details: 'GFA: 2756 m² // Estimated budget: €3M excl. VAT + €0.8M excl. VAT (VRD) // Client: ACM'
          },
          {
            title:
              'Construction of 52 homes – ZAC Carrière des Amoureux – Macrolot A – Garons',
            details:
              'GFA: 2800 m² // Client: SPL AGATE // Developer: ANGELOTTI PROMOTION // Social landlord: UN TOIT POUR TOUS'
          },
          {
            title:
              'Construction of 60 homes – ZAC Carrière des Amoureux – Macrolot C – Garons',
            details:
              'GFA: 3991 m² // Client: SPL AGATE // Developer: ANGELOTTI PROMOTION // Social landlord: UN TOIT POUR TOUS'
          }
        ]
      },

      experiencePro: {
        title: 'Professional experience',
        periods: [
          {
            years: 'October 2014',
            description: 'Creation of Daniela PARITO Architecture (SARL)'
          },
          {
            years: '1998 to 2014 – Arles - Montpellier',
            description: 'Professional experience in agencies:',
            agencies:
              'BOYER-PERCHERON-ASSUS // Antoine GARCIA-DIAZ // François FONTES // François SEIGNEUR'
          },
          {
            years: '1990 to 1998 - Paris',
            description: 'Professional experience in agencies:',
            agencies:
              'VALODE & PISTRE // SCENOGRAPHIE // Scène // Antoine STINCO // Bernard KHON // Pierre EIDEKINS // DONATI-DUBORG // Élisabeth DOUSSET // GUFROY-HESTERS-LEFEBVRE'
          }
        ]
      }
    },

    projectDetails: {
      1: {
        // Zac PIERRES VIVES
        subtitle:
          '“Alfred Screve” Residence - 48 social housing units in Montpellier, Lot 5 \nZAC Pierres Vives, Rue Marius Petipa, Montpellier (34000)',
        shortDescription:
          'A modern 48-home residence integrating green spaces and shared amenities.',
        fullDescription:
          'This residence is located at the heart of the ZAC Pierres Vives, a 10-hectare eco-district at the junction of several Montpellier neighborhoods. Pierres Vives is both residential and cultural, centered around the Departmental Archives—an iconic building by Zaha Hadid. \nThe building, set along the southern edge of the protected wooded park, offers an urban façade to the south and a landscaped façade to the north. It includes 48 cross-through apartments, accessed via open-air walkways overlooking the protected woodland. \nIt is an all-concrete building, emphasized by the horizontality of its bands and split terraces. Like a weave, the white bands undulate, dressing and softly wrapping the volumes. \nThis architecture of organic, natural forms delivers a homogeneous and coherent treatment. \nTo the south, it acts as a protective screen against “urban” nuisances: the bands alternately serve as terrace guardrails and as shading devices. They set the built volume back and enhance privacy for outdoor private spaces. To the north, it opens and blends into the natural landscape: the bands become guardrails for the walkways and offer open views over the protected woodland park. At the south-west corner, the bands cantilever from the façade and accompany the urban corner.',
        details: {
          mission: 'Award-winning competition - Design–Build',
          surface: '3391 m²',
          cost: '€4.4M excl. VAT',
          architecteAssocie: 'R+C2',
          performance: 'RT 2012',
          duration: '16 months',
          client: 'Hérault Habitat',
          year: '2019',
          team: [
            'Structural engineer: PER INGENIERIE',
            'MEP engineer: Cabinet DURAND',
            'SPS coordinator: ELYFEC',
            'Surveyor: GEO MECA',
            'Control bureau: DEKRA'
          ]
        }
      },

      2: {
        // RESIDENCE PARK VIEW
        subtitle:
          '“Park View” Residence - 32 owner-occupied homes - Lot 23C2 \n“Ovalie” district, Montpellier (34000)',
        shortDescription:
          'An innovative residential development in the heart of Ovalie, focused on quality of life and energy efficiency.',
        fullDescription:
          'The exceptional location of these homes—set back from major urban roads and facing Parc du Rieucoulon—naturally led the architect to adopt a cascading massing, providing each apartment with privileged exposure and views. \nFor most of the 32 cross-through units, the orientation of living spaces, terraces and loggias was designed around the surrounding landscape. \nResidents all have access to the calm shared garden of the residence and, beyond, the park itself. \nThe transition between private spaces and the outside is handled through a concrete brise-soleil device shaped like a portico, positioned in front of the façades. It provides shade and coolness to the dwellings and frames views—like a “window opening onto the Park”… through which one can observe the natural landscape while preserving the privacy of private terraces.',
        details: {
          mission:
            'Design services and architectural supervision (Delivered – October 2019)',
          surface: '1809 m²',
          cost: '€2.5M excl. VAT',
          client: 'Les Villégiales - Cogim',
          year: '2019',
          performance: 'RT 2012',
          duration: '20 months',
          team: [
            'Structural engineer: Structure 2000',
            'MEP engineer: Cabinet DURAND',
            'Cost consultant + OPC: K2C BET',
            'Surveyor: EGSA',
            'Control bureau: SOCOTEC'
          ]
        }
      },

      3: {
        // RESIDENCE PELLISSIER
        subtitle:
          '“Maison Pélissier” Residence - 20 subsidized multi-family homes in Mauguio (34130)',
        shortDescription:
          'A contemporary residential ensemble combining clean lines and comfort in the city center.',
        fullDescription:
          'Integrating a two-storey residence (R+2) into a neighborhood mainly composed of villas guided the architect’s approach. She preserved the balance of the area by inserting the building into its architectural and cultural context. \nThe apartments are well oriented, bright, and all cross-through, surrounding a landscaped, planted inner courtyard that serves the dwellings, all opening onto this convivial shared space. The use of stone at ground level and on parts of the façades echoes the identity of the town center. \nSupported by the municipality, the project respects the character of Mauguio: a town where traditions blend with modernity. \nSpecial attention was given to the building corner at the intersection of two streets. It was carved out to provide shelter for “bullfighting enthusiasts” during local festivals, when bulls pass through this point toward the former road to the cabins. \nThe rounded gable on the street is also a nod to the traditional herdsman’s hut.',
        details: {
          mission:
            'Design services and architectural supervision (Delivered – August 2022)',
          surface: '1460 m²',
          cost: '€1.4M excl. VAT',
          client: 'Ametis',
          year: '2022',
          performance: 'RT 2012',
          team: [
            'Structural engineers: RELIEF GE, BRINAS',
            'MEP engineer: ABM Énergie Conseil',
            'Cost consultant + OPC: K2C BET',
            '3D Manager',
            'Surveyor: EGSA',
            'Control bureau: QUALICONSULT'
          ]
        }
      },

      4: {
        // CITE MARCADAL
        subtitle:
          'Demolition of 49 homes & construction of 50 social housing units in Florensac (34510)',
        shortDescription:
          'A respectful urban renewal project, creating dialogue between tradition and modernity.',
        fullDescription:
          'The guiding thread of this project was the need to bring new conviviality to an aging neighborhood. New places were created, combining welcoming and functional housing with an improved quality of life through the organization and treatment of public spaces—making them facilitators of living well together. \nThe design of the homes, all cross-through with living rooms oriented south, meets energy-saving requirements. \nThe operation is carried out in three phases: 49 homes are gradually demolished and 50 are built, as semi-detached or terraced villas (R+1), arranged in small clusters forming four ensembles within a single neighborhood. \nPeople are placed at the heart of the project through key choices: organized pedestrian and cycle connections, easy access to groups of houses, simplified car access parked outside the residential zones… \nThe chosen layout ventilates the built mass and enables lateral openings for the homes. \nThe project uses a limited number of dwelling typologies (7 modules for 50 homes), allowing each module to be combined “freely” around a central core composed of bedrooms and/or living spaces/garages. This promotes compactness and frees space for private gardens.',
        details: {
          mission: 'Award-winning competition - Full service (Construction in progress)',
          surface: '3643 m²',
          cost: '€5.9M excl. VAT',
          client: 'Hérault-Logement',
          year: 'Ongoing',
          architecteAssocie: 'ARCHIZ',
          performance: 'RT 2012',
          duration: '36 months (ongoing)',
          team: [
            'Multidisciplinary engineering: BETEM',
            'Asbestos removal & demolition: ANTEA',
            'Civil engineering (VRD): Cabinet SEIRI',
            'Cost consultant + OPC: BPTEC',
            'Control bureau: DEKRA',
            'Surveyor: SIRAGUSA'
          ]
        }
      },

      5: {
        // RESIDENCE LES SEMAILLES
        subtitle:
          '“Les Semailles” Residence - Construction of 20 social housing units in Maraussan (34370)',
        shortDescription:
          'Eco-responsible multi-family housing with shared gardens and planted communal spaces.',
        fullDescription:
          'The architect’s objective was to create continuity and a new landscaped promenade axis between the lower town and the former Cooperative Winery—an historic symbol of the town and its agricultural tradition. This translated into open, convivial Mediterranean spaces where the new homes integrate harmoniously: all cross-through and perfectly functional. \nThe two residential bands, designed as distinct building bodies, are distributed on either side of this landscaped spine, following the natural slope of the site. \nOpen-air stair cores are inserted between the blocks. They are treated like sky-open fissures that segment the volumes and create a scale consistent with surrounding buildings. \nThis layout creates an open perspective toward the top of the site and beyond, and provides an intuitive distribution of homes, encouraging encounters and sharing among neighbors.',
        details: {
          mission: 'Award-winning competition - Full service (Delivered – 2018)',
          surface: '1288 m²',
          cost: '€1.9M excl. VAT',
          client: 'Hérault-Habitat',
          year: '2018',
          duration: '14 months',
          performance: 'RT 2012',
          team: [
            'Structural engineer: ITS',
            'MEP engineer: Cabinet DURAND',
            'Civil engineering (VRD): Cabinet SEIRI',
            'Cost consultant + OPC: BPTEC',
            'Control bureau: DEKRA',
            'Surveyor: Guillaume GASQUEZ'
          ]
        }
      },

      6: {
        // RESIDENCE LA VIGNERONNE
        subtitle:
          '“La Vigneronne” Residence - Demolition of the former cooperative winery and construction of 26 social housing units in Maureilhan (34370)',
        shortDescription:
          'Contemporary Mediterranean architecture inspired by the local wine-growing terroir.',
        fullDescription:
          'Reconciling tradition, aesthetics, efficiency and sobriety guided the design of these homes in a town with a strong wine-growing heritage. On the site of the former cooperative winery, the cleared perspective was enhanced to showcase the location. Roofs alternate between flat and tiled, recalling the shapes and colors of the former wine building. To meet our eco-design objective, the project is based on simple, efficient, pragmatic principles: \n- Maintain dense, compact volumes with few façade offsets to minimize heat loss and support low-consumption goals. \n- Stack volumes and use straightforward construction methods to improve project economy. \n- Offer cross-through dwellings enabling summer cross-ventilation to “relieve” buildings of heat.',
        details: {
          mission: 'Award-winning competition - Full service (Delivered – July 2021)',
          surface: '1666 m²',
          cost: '€2.2M excl. VAT',
          client: 'FDI Habitat',
          year: '2021',
          performance: 'RT 2012',
          duration: '16 months',
          team: [
            'Structural engineer: André VERDIER',
            'MEP engineer: Cabinet DURAND',
            'Civil engineering (VRD): Cabinet SEIRI',
            'Cost consultant + OPC: BPTEC',
            'Surveyor: E.G.S.A BTP',
            'Control bureau: DEKRA'
          ]
        }
      },

      7: {
        // Logements collectifs Frontignan
        subtitle: 'Construction of 24 multi-family homes in Frontignan (34110)',
        shortDescription:
          'A multi-family housing ensemble that integrates harmoniously into the existing urban fabric.',
        fullDescription:
          'The project includes 24 homes, most of them cross-through. \nThe massing follows the site’s morphology. In this configuration, the building body is fragmented, creating a play of shifted volumes and shadows that animate the façades. \nTiled roofs echo the surrounding urban fabric. \nThe open perspective that currently highlights the vineyard from Rue de Belgique is preserved. \nThe overall composition favors a traditional expression. The selected palette is soft; the architecture is primarily shaped by its volumes and the rhythm of openings. \nThe pedestrian access path runs alongside the building and serves each entrance hall as well as dedicated bicycle storage. At the entrance halls, localized widening of the path improves pedestrian and bicycle flow and encourages exchanges and social ties among residents.',
        details: {
          mission: 'Design services and architectural supervision (Project discontinued)',
          surface: '1621 m²',
          cost: '€2.0M excl. VAT',
          client: 'Ideom',
          performance: 'RT 2012',
          duration: '12 months',
          team: [
            'Structural engineer: Setting',
            'MEP engineer: DEXO',
            'Surveyor: GEOM 7',
            'Control bureau: SOCOTEC'
          ]
        }
      },

      8: {
        // Résidence Patio Clémént
        subtitle:
          'Patio Clément Residence - 34 multi-family homes including 11 subsidized units in Mauguio (34130)',
        shortDescription:
          'A city-center housing program combining tradition and modern architectural language.',
        fullDescription:
          'Located in the center of Mauguio, the project provides 34 homes, including 11 subsidized rental units. \nIt is composed of two aligned building bodies along Avenue Jean-Baptiste Clément, each subject to specific local planning rules (PLU). \nThe first, over two levels, is treated with a two-slope canal-tile roof, ensuring continuity of the urban frontage with the neighboring building. \nThe second, over three levels above an open parking structure, turns back at a regulation distance along the north-west boundary. On the top level, the façades are clad with ribbed zinc panels to cover the wall portions following the required setback slope. The choice and form of this cladding give the building a perceived “attic” character. \nThe link between the two bodies is marked by a large accessible through-terrace, visible from Avenue Jean-Baptiste Clément. It forms the transition volume between the two built forms. \nMaterials are traditional, simple and robust, with naturally contrasted yet restrained tones and textures. Openings favor verticality and are fitted with hinged or sliding shutters, harmonizing with surrounding buildings. Terrace guardrails are either solid or made of powder-coated cut metal featuring a vegetal motif.',
        details: {
          mission:
            'Design services and architectural supervision (Delivered – March 2023)',
          surface: '1924 m²',
          cost: '€2.6M excl. VAT',
          client: 'Angelotti Promotion',
          year: 'Ongoing',
          performance: 'RT 2012',
          duration: '14 months',
          team: [
            'Structural engineer: Per Ingénierie',
            'MEP engineer: Betso',
            'Surveyor: RELIEF GE',
            'Control bureau: SOCOTEC'
          ]
        }
      },

      9: {
        // Le Chemin des Vignes
        subtitle:
          'Construction of 69 homes – “Le Chemin des Vignes” subdivision - Port-la-Nouvelle (11210)',
        shortDescription:
          'A large residential ensemble designed as a lived-in park, prioritizing greenery and conviviality.',
        fullDescription:
          '“Living in a Park.” \nThrough this project, we sought a unity of landscape so the site can be perceived as a single entity, preserving the tranquility of future occupants. \nWe worked carefully on building placement and view orientation toward the central inner space, and set the built volumes away from neighboring houses by placing the parking area and a planted tree buffer along the boundary. \nWe prioritized major transparencies and vegetated continuities, avoiding parallel frontality between buildings. \nAll homes will benefit from views over the residence’s green spaces as much as possible. A shared garden—where nature has an aesthetic, practical and nourishing role—becomes a true place for exchange and relaxation among neighbors. \nThe treatment of buildings aims to assert architectural and urban unity through the choice of materials, tones and recurring architectural details across façades, while also affirming differentiated forms depending on orientation, overlooking conditions, typologies and specific needs.',
        details: {
          mission: 'Design services and architectural supervision (Tender documents in progress)',
          surface: '4303 m²',
          cost: '€7.0M excl. VAT',
          client: 'HABITAT AUDOIS',
          year: 'Ongoing',
          team: [
            'Engineering: DELORME',
            'MEP engineer: Cabinet DURAND',
            'Engineering: RELIEF GE',
            'Environmental: AZUR ENVIRONNEMENT',
            'Surveyor: ORRIT - BLANQUER',
            'Control bureau: SUD-EST PREVENTION'
          ],
          duration: '20 months',
          performance: 'RE2020'
        }
      },

      10: {
        // Maison individuelle Baillargues
        subtitle:
          'Single-family home – “Georges Bizet” neighborhood in Baillargues (34670)',
        shortDescription:
          'A contemporary Mediterranean villa integrated into its natural surroundings.',
        fullDescription:
          'This villa was designed to integrate with the site while respecting Mediterranean codes. It faces south and develops longitudinally along the east–west axis. The private garden wraps around the villa. \nThe building is organized around a central double-height volume housing the living room, whose large south-facing bay windows and wooden terrace are protected by a generous wood-and-metal pergola. \nThe overall massing—simple and homogeneous—was designed to preserve the existing vegetation on the plot. The flat roof is greened. \nThe villa’s north-east corner, facing the entrance, is marked by natural stone cladding, recalling the dry-stone boundary wall specified by the developer.',
        details: {
          mission: 'Design services (Mission completed)',
          surface: '128 m²',
          cost: '€0.16M excl. VAT',
          client: 'Private',
          duration: '6 months',
          year: 'Completed',
          team: ['Surveyor: DEGEMA']
        }
      },

      11: {
        // Maison BBC Mondonville
        subtitle: 'Passive timber-frame single-family home in Mondonville (31700)',
        shortDescription: 'A high-energy-performance passive timber-frame home.',
        fullDescription:
          'This house was built with a timber frame and natural insulation. Its design ensured coherence of the thermal envelope, placing the home within a “passive energy” approach. \nThe building develops longitudinally. Single-storey and south-facing, it is organized around the entrance volume, above which we created an accessible terrace. This element— a true “pivot” of the building—forms a “fissure” that both separates the night and day zones, creates a through-view and access to the large garden in front of the house, adapts the orientation of the volumes, and benefits from the best solar exposure. \nThe volumes are composed of simple, homogeneous forms. The mono-pitch roof turns toward the central garden to give this living area an intimate, protected character. \nThe north side, facing the neighbor’s house and the access path, contains the less noble rooms that do not require large openings. The south side accommodates living spaces and bedrooms, benefiting from maximum sunlight.',
        details: {
          mission: 'Design services (Delivered)',
          surface: '130 m²',
          cost: '€0.2M excl. VAT',
          client: 'Private',
          year: '2016',
          duration: '8 months',
          performance: 'BBC',
          team: ['Surveyor: URBACTIS']
        }
      },

      12: {
        // Club House Baillargues
        subtitle:
          'Community facility (Club House) and renovation of stadium changing rooms in Baillargues (34670)',
        shortDescription:
          'A modern sports facility combining functionality and conviviality.',
        fullDescription:
          'The design of the Baillargues stadium community facility made it possible to harmonize renovation of the existing part with an extension. A choice of noble and durable materials—while remaining financially accessible—helped integrate the building into its overall sports environment. The first stated objective? To be a warm, functional welcoming place for the Brazil team during the Women’s Football World Cup in July 2019. The second? For the town’s many clubs to appropriate it as their meeting place. A successful bet, judging by the usage rate of these facilities…',
        details: {
          mission: 'Full service + OPC (Delivered – May 2018)',
          surface: '213 m²',
          cost: '€0.15M excl. VAT',
          client: 'Town of Baillargues',
          year: '2018',
          duration: '3 months',
          team: [
            'Structural engineer: SEGE Ingénierie',
            'Cost consultant: EXEOP',
            'Control bureaus: QUALICONSULT'
          ]
        }
      },

      13: {
        // Poste Police Baillargues
        subtitle:
          'Rehabilitation of “Maison Galibert” into a Municipal Police Station in Baillargues (34670)',
        shortDescription:
          'Heritage rehabilitation of a historic building into a modern public facility.',
        fullDescription:
          'A well-integrated community police service is one of the key guarantees of its effectiveness. The heavy rehabilitation of a dwelling—the “Maison Galibert”—to create a police station with modern functions guided the work, ensuring long-term architectural integration in a protected area. \nThe building includes the control and supervision center for the town’s urban video surveillance, offices, locker rooms and sanitary facilities, as well as a break area for agents, with a public reception area on the ground floor. \nThe external volume is preserved and restored: reuse of original “canal” tiles for the covered roof, preservation of façade moldings, new aged-zinc gutters. \nIn addition, to keep traditional arrangements, the façade was stripped and then rendered in three layers of natural lime with a color almost identical to the original. \nWindow joinery is painted wood in a grey tone. Wooden shutters are a few shades darker.',
        details: {
          mission: 'Full service (Delivered – June 2021)',
          surface: '63 m²',
          cost: '€0.16M excl. VAT',
          client: 'Town of Baillargues',
          year: '2021',
          duration: '7 months',
          team: [
            'Structural engineer: Agi Technique',
            'DET + OPC: EXEOP',
            'Surveyor: SOLEA BTP',
            'Control bureau: ALPES CONTROLES'
          ]
        }
      },

      14: {
        // Stade René Franqués
        subtitle:
          'Sports facilities design team - Stade René Franques in Florensac (34510)',
        shortDescription:
          'A modern, dynamic sports facility with a strong contemporary architectural identity.',
        fullDescription:
          'The project, initiated by the Town of Florensac, aims to be a building that reflects its use: functional, dynamic, young and timeless. \nThe single-storey building is designed symmetrically along the central axis of the football field. On each side are: four changing rooms with showers, restrooms, offices and technical rooms. \nTwo adjoining built volumes are clearly legible. Their purpose is to provide independent access between players and the public, and to create a play of volumes that amplifies the dynamic, contemporary character of the architecture. \nThe 207-seat stands extend on either side of the access tunnel to the field from the changing rooms. \nWhile keeping a classic structure, the color choices, the play of access to the field and stands, and the metal canopy—like a totem—give the building presence and grounding.',
        details: {
          mission: 'Full service (Delivered – December 2022)',
          surface: '445 m² + 164 m² (stands)',
          cost: '€0.8M excl. VAT',
          client: 'Town of Florensac',
          year: '2022',
          duration: '8 months',
          team: [
            'Structural engineer: Its',
            'MEP engineer: Cabinet DURAND',
            'Cost consultant: BPTEC',
            'DET + OPC: EXEOP',
            'Surveyor: BBAS',
            'Control bureau: SOCOTEC'
          ]
        }
      },

      15: {
        // ZAC Cambacérès
        subtitle:
          'ZAC CAMBACERES - Lot B.1.1 - Construction of 39 multi-family homes in Montpellier (34000)',
        shortDescription: 'A multi-family housing project in ZAC Cambacérès.',
        fullDescription:
          'We conceived our project as an integrated entity in harmony with a landscape of strong natural and cultural connotations: “A residence extending the Park”, a foretaste of the large Mas des Brousses Park located opposite. \nThe future building will therefore be part of this broad rural landscape, creating the transition between the park and the new neighborhood.',
        details: {
          mission: 'Design team competition (October 2018)',
          surface: '2756 m²',
          cost: '€3.0M excl. VAT (works) + €0.8M excl. VAT (VRD)',
          client: 'ACM HABITAT',
          year: '2018',
          architecteAssocie: 'ARCHIZ',
          team: [
            'Structural engineer: André VERDIER',
            'MEP engineer: Cabinet DURAND',
            'Civil engineering (VRD): Cabinet SEIRI'
          ]
        }
      },

      16: {
        // 7 avenue de la Gardie Florensac
        subtitle:
          'Demolition and construction of 27 social rental homes - 7 Avenue de la Gardie – Florensac',
        shortDescription:
          'Urban renewal with the construction of social housing in Florensac.',
        fullDescription:
          'The overall site strategy is based on organizing a new centrality, providing: \n- The creation of an “inner courtyard” at the heart of the residence, creating a new focal point for future residents; \n- The initiative of a diversified housing offer (small apartment block, stacked villas); \n- The creation of a central green lung in continuity with the surrounding vegetable gardens and orchards. \nOur project, with diversified urban forms, grafts onto the village fabric while seeking a harmonious connection with its immediate surroundings.',
        details: {
          mission: 'Competition (October 2020)',
          surface: '1910 m²',
          cost: '€2.3M excl. VAT',
          client: 'Hérault-Logement',
          year: '2020',
          team: [
            'Structural engineer: ITS 3.0',
            'MEP engineer: Cabinet DURAND',
            'Civil engineering (VRD): Cabinet SEIRI',
            'Costing/MOEX/OPC: EXEOP'
          ]
        }
      },

      17: {
        // Secteur Martinet Langlade
        subtitle:
          'ZAC “Cœur de Village” - Construction of 39 homes \nMartinet sector, Municipality of Langlade (30980)',
        shortDescription:
          'A mixed neighborhood of housing and services in the heart of the village of Langlade.',
        fullDescription:
          'In line with the municipality’s objectives, the proposal is based on a mix of densities and complementary housing typologies (apartment building, grouped villas, co-housing homes and a shared room) grafted onto the existing village and suburban fabric, framing the Festivities Square (new centrality) adjacent to future public facilities.',
        details: {
          mission: 'Competition (November 2020)',
          surface: '3110 m²',
          client: 'SPL AGATE',
          promoteur: 'ANGELOTTI PROMOTION',
          bailleur: 'UN TOIT POUR TOUS',
          year: '2020'
        }
      },

      18: {
        // Macro-lot C Garons
        subtitle:
          'Construction of 60 homes - Macrolot C, ZAC Carrière des Amoureux in Garons (30128)',
        shortDescription:
          'A large residential ensemble in the ZAC Carrière des Amoureux.',
        fullDescription:
          'For our project, we sought a unity of landscape—a perception of the site as a single entity. A serene, natural living environment for future residents. \nWe created two building bodies articulated around a central, ventilated, crossing inner courtyard, punctuated by access halls and ground-floor private entrances, richly planted. \nAt pedestrian scale, this arrangement encourages strolling, permeability of uses, offers views onto a changing vegetated landscape through the seasons, avoids monotony, and supports the appropriation of outdoor spaces.',
        details: {
          mission: 'Competition (November 2020)',
          surface: '3991 m²',
          client: 'SPL AGATE',
          promoteur: 'ANGELOTTI PROMOTION',
          bailleur: 'UN TOIT POUR TOUS',
          year: '2020'
        }
      },

      19: {
        // Îlot Saint-Esprit Béziers
        subtitle:
          'Construction of 6 homes and a ground-floor retail unit - Capnau district “Îlot Saint-Esprit” in Béziers (34500)',
        shortDescription:
          'A mixed-use program of housing and retail in the heart of Béziers.',
        fullDescription:
          'To preserve the particular “strategic” character of this block, our proposal was conceived as a “signal insertion”, aimed at enhancing the site through contemporary and original architecture. This creates a link between Place de la Madeleine and the entrance to the Capnau district, and also serves as an attractor for visitors. \nBy relating materials and volumes, we sought both confrontation and reconciliation between past and present—connecting the “historic” city with a more contemporary expression, through a clean, simple and bold geometric composition.',
        details: {
          mission: 'Competition (October 2019)',
          surface: '268 m² (housing) + 75 m² (retail)',
          client: 'City of Béziers',
          promoteur: 'ANGELOTTI PROMOTION / PROMO G',
          year: '2019'
        }
      },

      20: {
        // Macro-lot A Garons
        subtitle:
          'Construction of 52 homes - Macrolot A, ZAC Carrière des Amoureux in Garons (30128)',
        shortDescription:
          'A residential ensemble in the ZAC Carrière des Amoureux.',
        fullDescription:
          'Our project proposes a way of “living” the large landscape, where buildings have a privileged relationship with the surrounding environment, retention basins, vegetable gardens and planted spaces within the residence. \nLandscape is considered a resource benefiting each home and each inhabitant. \nAs a result, the project integrates all technical constraints: not closing buildings in on themselves, opening homes generously to the omnipresent landscape, respecting the quality of shared spaces, encouraging the use of soft mobility, and building with the qualities of its territory by favoring local construction sectors. The notion of large landscape can be appreciated at the scale of one’s home, one’s garden, from the courtyard square, from the central pedestrian spine, or even from the public street.',
        details: {
          mission: 'Competition (November 2020)',
          surface: '2797 m²',
          client: 'SPL AGATE',
          promoteur: 'ANGELOTTI PROMOTION',
          bailleur: 'UN TOIT POUR TOUS',
          year: '2020'
        }
      },

      21: {
        // ZAC Puits de Roulle Nîmes
        subtitle: 'ZAC “Puits de Roulle” - Lot 7 - Nîmes - Construction of 34 homes',
        shortDescription: 'A residential program in ZAC Puits de Roulle in Nîmes.',
        fullDescription:
          'Construction project of 34 homes in Lot 7 of the ZAC “Puits de Roulle” in Nîmes. A program perfectly integrated into the landscape and embracing the site’s topography. \nThe project is part of the ZAC Puits de Roulle perimeter. \nIt is structured around the following principles: \n- Development that respects the site’s natural topography \n- Preservation of existing vegetation \nAn architecture inspired by the theme of “Mediterranean nature”.',
        details: {
          mission: 'Competition (November 2021)',
          surface: '2208 m²',
          client: 'City of Nîmes',
          promoteur: 'ENVOL',
          year: '2021'
        }
      },

      22: {
        // Étude Concept - Microstation dédiée (GAZ GNV)
        subtitle: 'A completely innovative service-station concept for private individuals.',
        shortDescription:
          'A completely innovative service-station concept for private individuals.',
        fullDescription:
          'The SEVEN Group (a company that invests, develops, builds and operates more than 15 “green multi-energy” stations in France for road transport) wanted to address a new market: light vehicles running on bio-gas or hydrogen. Its President asked us to imagine a completely innovative service-station concept for private individuals. The goal was to build micro-stations at a moderate cost through standardization of factory-built structures, while minimizing on-site construction interventions and facilitating maintenance of technical equipment. The solution we proposed combined aesthetics (a sleek, modern line), practicality for both customer and station owner, cost-controlled reproducibility, while maintaining adaptability to different target vehicle types (lengths), technical specifications and site configurations.',
        details: {
          mission: 'Prototype study',
          client: 'SEVEN',
          year: '2018',
          promoteur: 'Client: SEVEN OCCITANIE'
        }
      },

      23: {
        // Cité des Peupliers à Narbonne
        subtitle:
          'Delivery of a 50-home residential program – Cité des Peupliers in Narbonne (11100)',
        shortDescription:
          'A 50-home residential program in Cité des Peupliers in Narbonne.',
        fullDescription:
          'Call for applications as part of the sale of land for the delivery of a residential program - 8 Rue des Peupliers, Narbonne. \nThe project aims to integrate sustainable development dimensions and promote biodiversity, notably through strengthening a real green-and-blue network. \nThe creation of shared communal spaces, fostering social ties and contributing to changing the neighborhood’s image, is one of the project’s key challenges. The creation of a pedestrian network and the development of soft mobility modes will contribute to opening up the neighborhood.',
        details: {
          mission: 'Competition (March 2023)',
          surface: '2208 m²',
          client: 'City of Narbonne',
          promoteur: 'ENVOL',
          year: '2023',
          cost: '€2.3M excl. VAT'
        }
      }
    },

    projectDescriptions: {
      1: 'A modern 48-home residence integrating green spaces and shared amenities.',
      2: 'An innovative residential development in the heart of Ovalie, focused on quality of life and energy efficiency.',
      3: 'A contemporary residential ensemble combining clean lines and comfort in the city center.',
      4: 'A respectful urban renewal project, creating dialogue between tradition and modernity.',
      5: 'Eco-responsible multi-family housing with shared gardens and planted communal spaces.',
      6: 'Contemporary Mediterranean architecture inspired by the local wine-growing terroir.',
      7: 'A housing ensemble integrating harmoniously into the existing urban fabric.',
      8: 'A city-center housing program combining tradition and modern architectural language.',
      9: 'A large residential ensemble designed as a lived-in park, prioritizing greenery and conviviality.',
      10: 'A contemporary Mediterranean villa integrated into its natural surroundings.',
      11: 'A high-energy-performance passive timber-frame home.',
      12: 'A modern sports facility combining functionality and conviviality.',
      13: 'Heritage rehabilitation of a historic building into a modern public facility.',
      14: 'A modern, dynamic sports facility with a strong contemporary architectural identity.',
      15: 'A multi-family housing project in ZAC Cambacérès.',
      16: 'A residential development at the heart of the village of Langlade.',
      17: 'A residential ensemble in the ZAC Carrière des Amoureux.',
      18: 'Urban renewal with the construction of social housing in Florensac.',
      19: 'A residential program in ZAC Puits de Roulle in Nîmes.',
      20: 'A mixed-use program of housing and retail in the heart of Béziers.',
      21: 'A large residential ensemble in the ZAC Carrière des Amoureux.'
    },

    projectDetail: {
      // Header
      backToProjects: 'Back to projects',

      // Sections
      description: 'Description',
      informations: 'Information',

      // Information fields
      mission: 'Scope',
      surface: 'Area',
      cost: 'Cost',
      client: 'Client',
      year: 'Year',
      team: 'Team',
      architecteAssocie: 'Associate Architect',
      promoteur: 'Developer',
      bailleur: 'Social Landlord',
      duration: 'Construction duration',
      performance: 'Energy performance',

      // Messages
      notFound: 'Project not found',
      noDescription: 'Description not available'
    },

    newsData: [
      {
        id: 1,
        date: "October 2019",
        category: "Delivery",
        title: "Park View Residence - ZAC Ovalie, Montpellier",
        excerpt: "Completion of the Park View residence: 32 owner-occupied homes in the Ovalie district of Montpellier. A project designed to maximize exposure and views over Parc du Rieucoulon."
      },
      {
        id: 2,
        date: "October 2019",
        category: "Article",
        title: "COGIM - Park View Residence in the press",
        excerpt: "Press article featuring the Park View residence delivered for COGIM in the Ovalie district. A contemporary architecture in dialogue with its surroundings."
      },
      {
        id: 3,
        date: "May 2019",
        category: "Article",
        title: "Baillargues ready to welcome the players of the FIFA Women's World Cup",
        excerpt: "Press article presenting the restructuring of the football club changing rooms building in Baillargues, including the creation of a dedicated 50 m² club space."
      },
      {
        id: 7,
        date: "May 2026",
        category: "Urban Planning",
        title: "ZAN in the Hérault: how to build when land becomes scarce",
        excerpt: "Zero Net Land Take is reshaping construction in the Hérault. Less land for urban extension, priority to urban renewal and rehabilitation: here is what it concretely changes for your projects, and the architect's role in building dense and high-quality."
      },
      {
        id: 8,
        date: "April 2026",
        category: "Expertise",
        title: "Mediterranean Bioclimatic Architecture: Staying Cool Without Air Conditioning in the Hérault",
        excerpt: "In the Hérault, located in climate zone H3, summer puts homes to the test. Mediterranean bioclimatic design keeps a house cool without air conditioning while meeting the RE2020 summer comfort thresholds. DP Architecture walks you through the concrete levers."
      },
      {
        id: 9,
        date: "March 2026",
        category: "Advice",
        title: "Thermal Sieves in Hérault: Understanding the Timeline and Succeeding in Your Energy Renovation",
        excerpt: "A ban on renting out DPE G, F and then E homes: the thermal-sieve timeline is taking shape. Here is what it means for owners and landlords in Hérault, and the architect's role in an in-depth energy renovation."
      },
      {
        id: 4,
        date: "January 2025",
        category: "Expertise",
        title: "RE2020 in Hérault: building sustainably with an expert architect",
        excerpt: "The 2020 environmental regulation is profoundly transforming architectural practices. Discover how DP Architecture guides you through your sustainable construction projects in Hérault."
      },
      {
        id: 5,
        date: "November 2024",
        category: "Projects",
        title: "Collective housing in Montpellier and Hérault: 30 years of expertise",
        excerpt: "DP Architecture is a recognised specialist in collective housing construction in Hérault. A look back at 30 years of achievements across Montpellier, Mauguio, Florensac and the wider Hérault area."
      },
      {
        id: 6,
        date: "September 2024",
        category: "Advice",
        title: "Building your individual home in Hérault with an architect",
        excerpt: "Choosing an architect for your individual home in Hérault means opting for a bespoke service, a quality guarantee, and expertise in contemporary Mediterranean architecture."
      }
    ],

    cityPage: {
      region: "Hérault (34) — Occitanie",
      heroTitle: "Architect in",
      heroSubtitle: "Daniela Parito Architecture – 30 years of experience in the Hérault",
      ctaQuote: "Request a free quote",
      ctaProjects: "View our projects",
      introTitle: "DP Architecture in",
      statExp: "years of experience",
      statProjects: "projects delivered",
      statCert: "certified expertise",
      servicesTitle: "Our services in",
      servicesAnd: "and the Hérault",
      servicesIntro: "Daniela Parito Architecture works across all architectural typologies throughout the Hérault department.",
      service1Title: "Multi-family Housing",
      service1Items: [
        "Apartment blocks and residential complexes",
        "Intermediate and grouped housing",
        "RE2020 and BBC compliance",
        "Urban and landscape integration"
      ],
      service2Title: "Single-family Homes",
      service2Items: [
        "Bespoke contemporary villas",
        "Passive and BBC homes",
        "Extensions and renovations",
        "Mediterranean architecture"
      ],
      service3Title: "Commercial & Public Facilities",
      service3Items: [
        "Urban studies and ZAC",
        "Public facilities (ERP)",
        "Administrative buildings",
        "Sports and cultural facilities"
      ],
      projectsLocalTitle: "Our projects in",
      projectsLocalAnd: "and nearby",
      projectsNearbyTitle: "Our projects near",
      projectsIntro: "Discover our reference projects in your area.",
      projectsCta: "View all our projects",
      whyTitle: "Why choose DP Architecture in",
      why1Title: "Registered architect",
      why1Text: "Daniela Parito Sorrenti, an architect trained in Rome, has 30 years of experience in complex architectural design and project management across Occitanie.",
      why2Title: "RE2020 & BBC Expertise",
      why2TextA: "Full command of the most demanding environmental standards: RE2020, BBC, passive building and HQE. Your projects in",
      why2TextB: "will benefit from the highest energy performance.",
      why3Title: "Local Hérault Roots",
      why3Text: "Based in Montpellier since 2014, DP Architecture works throughout the Hérault department and has an in-depth knowledge of local regulatory and landscape constraints.",
      why4Title: "Budget Compliance",
      why4Text: "A firm commitment to staying within agreed budgets. Every project is subject to rigorous cost management, from design through to handover.",
      ctaTitle: "Your project in",
      ctaTitleEnd: "? Let's talk!",
      ctaText1: "Contact Daniela Parito Architecture for a free initial consultation. We work in",
      ctaText2: "and throughout the Hérault department (34).",
      ctaSend: "Send a message"
    },

    articlePage: {
      backToNews: "Back to news",
      inlineCtaText: "Do you have a project in the Hérault?",
      inlineCtaBtn: "Contact DP Architecture",
      sidebarContactTitle: "Your project in the Hérault",
      sidebarContactText: "Daniela Parito Architecture works throughout the Hérault department.",
      sidebarQuote: "Free quote",
      sidebarRelatedTitle: "Read also",
      sidebarCitiesTitle: "We work in"
    }
  }
};